webpackJsonp([1],Array(29).concat([
/* 29 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(98)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(41),
  /* template */
  __webpack_require__(127),
  /* scopeId */
  "data-v-7b5d5bd9",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 30 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(129);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Work__ = __webpack_require__(109);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Work___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_Work__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_WorkReact__ = __webpack_require__(112);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_WorkReact___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_WorkReact__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_WorkVueJs__ = __webpack_require__(114);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_WorkVueJs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_WorkVueJs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_WorkNodeJs__ = __webpack_require__(111);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_WorkNodeJs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_WorkNodeJs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_WorkRobotics__ = __webpack_require__(113);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_WorkRobotics___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_WorkRobotics__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_WorkIndustrySiemens__ = __webpack_require__(110);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_WorkIndustrySiemens___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__components_WorkIndustrySiemens__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_Project_vue__ = __webpack_require__(105);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_Project_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__components_Project_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_Home__ = __webpack_require__(103);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_Home___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__components_Home__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_Vision__ = __webpack_require__(108);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_Vision___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__components_Vision__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_Resume__ = __webpack_require__(106);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_Resume___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__components_Resume__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_ResumeShort__ = __webpack_require__(107);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_ResumeShort___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__components_ResumeShort__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_Error__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_Error___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__components_Error__);















__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  mode: 'history',
  routes: [{
    path: '/',
    name: '/',
    component: __WEBPACK_IMPORTED_MODULE_9__components_Home___default.a
  }, {
    path: '/home',
    name: 'Home',
    component: __WEBPACK_IMPORTED_MODULE_9__components_Home___default.a
  }, {
    path: '/vision',
    name: 'Vision',
    component: __WEBPACK_IMPORTED_MODULE_10__components_Vision___default.a
  }, {
    path: '/projects-react',
    name: 'React',
    component: __WEBPACK_IMPORTED_MODULE_3__components_WorkReact___default.a
  }, {
    path: '/projects-vue-js',
    name: 'Vue.js',
    component: __WEBPACK_IMPORTED_MODULE_4__components_WorkVueJs___default.a
  }, {
    path: '/projects-node-js',
    name: 'Node.js',
    component: __WEBPACK_IMPORTED_MODULE_5__components_WorkNodeJs___default.a
  }, {
    path: '/projects-robotics',
    name: 'Robotics',
    component: __WEBPACK_IMPORTED_MODULE_6__components_WorkRobotics___default.a
  }, {
    path: '/projects-industry-siemens',
    name: 'Industry-Siemens',
    component: __WEBPACK_IMPORTED_MODULE_7__components_WorkIndustrySiemens___default.a
  }, {
    path: '/projects',
    name: 'Work',
    component: __WEBPACK_IMPORTED_MODULE_2__components_Work___default.a
  }, {
    path: '/Resume',
    name: 'Resume',
    component: __WEBPACK_IMPORTED_MODULE_11__components_Resume___default.a
  }, {
    path: '/ResumeShort',
    name: 'ResumeShort',
    component: __WEBPACK_IMPORTED_MODULE_12__components_ResumeShort___default.a
  }, {
    path: '/work/:category/:slug',
    component: __WEBPACK_IMPORTED_MODULE_8__components_Project_vue___default.a
  }, {
    path: '*',
    component: __WEBPACK_IMPORTED_MODULE_13__components_Error___default.a
  }],
  scrollBehavior: function scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    } else {
      return { x: 0, y: 0 };
    }
  }
}));

/***/ }),
/* 31 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__store__ = __webpack_require__(39);

/* harmony default export */ __webpack_exports__["a"] = ({
  store: __WEBPACK_IMPORTED_MODULE_0__store__["a" /* default */],
  install: function install(Vue, options) {
    Vue.prototype.$myStore = __WEBPACK_IMPORTED_MODULE_0__store__["a" /* default */];
  }
});

/***/ }),
/* 32 */,
/* 33 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 34 */,
/* 35 */,
/* 36 */,
/* 37 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(91)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(40),
  /* template */
  __webpack_require__(120),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 38 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reset_css__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reset_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_reset_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_es6_promise_auto__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_es6_promise_auto___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_es6_promise_auto__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__App__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__App___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__App__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__router__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_lazyload__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_lazyload___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vue_lazyload__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vuex__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__storePlugin__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue_carousel__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue_carousel___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_vue_carousel__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vue_accordion_menu__ = __webpack_require__(34);













__WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_5_vue_lazyload___default.a, {
  preLoad: 1.3,
  attempt: 3,
  loading: '/static/images/loading.svg',
  adapter: {
    loaded: function loaded(_ref) {
      var el = _ref.el;

      el.parentElement.classList.add('loaded');
    },
    loading: function loading(_ref2) {
      var el = _ref2.el;

      el.parentElement.classList.remove('loaded');
    },
    error: function error(_ref3) {
      var el = _ref3.el;

      el.parentElement.classList.add('error');
    }
  }
});

__WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_6_vuex__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_7__storePlugin__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].config.productionTip = false;

__WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_8_vue_carousel___default.a);

__WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].component('AccordionMenu', __WEBPACK_IMPORTED_MODULE_9_vue_accordion_menu__["AccordionMenu"]);

new __WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */]({
  el: '#app',
  router: __WEBPACK_IMPORTED_MODULE_4__router__["a" /* default */],
  template: '<App/>',
  components: {
    App: __WEBPACK_IMPORTED_MODULE_3__App___default.a
  }
});

/***/ }),
/* 39 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(17);





__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */].Store({
  getters: {
    tabModeGet: function tabModeGet(state) {
      return state.tabMode;
    }
  },
  mutations: {
    increment: function increment(state) {
      state.tabMode++;
    },
    tabModeSet: function tabModeSet(state, value) {
      state.tabMode = value;
    }
  },
  state: {
    tabMode: 0,
    jobs: [{
      job_group_name: 'Career Objective',
      job_group_text: '&nbsp;',

      job_title: null,
      job_company: null,
      job_location: null,
      job_timePeriod: {
        from: null,
        to: null
      },

      job_childs: [{ text: 'After serving for 10-years as a \'Passionate\' Speaker at a Religious Center for: ' }, { text: '&nbsp; &nbsp; &#9656; Family Chapel Services (100+ attendance), Family Retreats (50+) & Jr/Sr High Outreaches (30+),' }, { text: 'I seek to serve the next \'10-years\' of my life, Teaching in a more Academic Context that utilizes my:' }, { text: '&nbsp; &nbsp; &#9656; Prior 10-years experience as a \'Web and Robotics\' Instructor & Curriculum Engineer and' }, { text: '&nbsp; &nbsp; &#9656; Dual Teaching-Diplomas from Mills College and Western Seminary, respectively.' }]

    }, {
      job_group_name: 'Education',
      job_group_text: '(Ascending Order to Tell A Chronological Story)',
      job_title: 'B.S. Electrical and Computer Engineering',
      job_company: 'University of California',
      job_location: 'Davis, CA',
      job_timePeriod: {
        from: 'Fall 1983',
        to: 'Spring 1988'
      },
      job_childs: [{ text: '&#9656; Dean\'s Honor List & Westinghouse Science Honors.' }, { text: '&#9656; Upper-Division Research Project on Fibre-Optics Digital Networks as sponsored by Hewlett-Packard (E&C 199).' }, { text: '&#9656; Upper-Division Final Project on Embedded-MicroController for Robotics (E&C 172).' }],

      skills_groups: [{
        skills_group_group_name: 'Dual Engineering Major: Software & Hardware',
        skills_group_group_text: '<span style="text-align:center;">The above two Upper-Division Projects -- Networks and MicroControllers -- nurtured my passion for <br>Web Full-Stack (Software) and Robotics (Hardware), respectively.</span>',
        skills_group_name: null,
        skills_group_text: null,
        skills_group_timePeriod: {
          from: null,
          to: null
        },

        skills: [{
          skill_head: null,
          skill_body: null,
          skill_link: null,
          skill_link_tab_index: null,

          skill_childs: [{ text: null }]
        }]
      }]
    }, {
      job_group_name: null,
      job_group_text: null,
      job_title: 'Math Single Subject Teacher Credential',
      job_company: 'Mills College',
      job_location: 'Oakland, CA',
      job_timePeriod: {
        from: 'Fall 1994',
        to: 'Summer 1995'
      },
      job_childs: [{ text: '&#9656; California Mathematics Single-Subject Professional Clear Credentialed.' }, { text: '&#9656; “Mid-Career Math & Science Teacher Preparation” Specialized Track.' }, { text: '&#9656; Student-Teaching with Stanford University -and- Institute for Research on Learning (IRL), Palo Alto CA.' }],
      skills_groups: [{
        skills_group_group_name: 'Teaching Diploma I: Pedagogy & Classroom Management',
        skills_group_group_text: '<span style="text-align:center;">Mills College\'s relationship with Stanford University equipped me to teach over a decade in settings <br>from a San Leandro public school\'s 120+ students/day to East Palo Alto inner-city youth projects.</span>',
        skills_group_name: null,
        skills_group_text: null,
        skills_group_timePeriod: {
          from: null,
          to: null
        },

        skills: [{
          skill_head: null,
          skill_body: null,
          skill_link: null,
          skill_link_tab_index: null,

          skill_childs: [{ text: null }]
        }]
      }]
    }, {
      job_group_name: null,
      job_group_text: null,
      job_title: 'Master of Arts, General Ministry',
      job_company: 'Western Seminary',
      job_location: 'San Jose, CA',
      job_timePeriod: {
        from: 'Fall 1996',
        to: 'Spring 2000'
      },
      job_childs: [{ text: '&#9656; Highest Honor for PTS 514: Expository Preaching/Teaching.' }, { text: '&#9656; Middle & High School Youth and Family Ministry Practicum.' }],

      skills_groups: [{
        skills_group_group_name: 'Teaching Diploma II: Large-Scale Speaking',
        skills_group_group_text: '<span style="text-align:center;">Western Seminary\'s program empowered my service as a Dynamic Orator for:<br>Family Sunday Services (100+ attendance), High School to Elementary Friday Chapels (50+) & Children Church (50+)</span>',
        skills_group_name: null,
        skills_group_text: null,
        skills_group_timePeriod: {
          from: null,
          to: null
        },

        skills: [{
          skill_head: null,
          skill_body: null,
          skill_link: null,
          skill_link_tab_index: null,

          skill_childs: [{ text: null }]
        }]
      }]
    }, {
      job_group_name: 'Teaching Experience #1 of 5',
      job_group_text: '(Descending Order with Most Current First)',
      job_title: 'Co-Founder, Instructor & Curriculum Engineer: Web Full-Stack & Robotics',

      job_company: 'Encourage and Empower (<scan style="color:red;font-weight:500;">EandE</scan>)',
      job_location: 'Milpitas, CA',
      job_url: 'http://www.EandE.world',
      job_timePeriod: {
        from: 'Sep 2006',
        to: 'Current'
      },
      job_childs: [{ text: '&#9656; Traditionally, I\'ve enjoyed coding and teaching Java, C#, and C++ -- among many other Linux-Based tools.' }, { text: '&#9656; Yet due to the global pervasiveness of Web-Services and Robotics, Stack Overflow\'s 2018 Global Survey of 100K Developers concludes that two Open-Source languages -- JavaScript and Python -- have taken the world by storm, at least for these past several years <a href="https://insights.stackoverflow.com/survey/2018" class="skillUrl" target="_blank" style="color:blue;text-decoration-line:underline;font-size:75%">[https://insights.stackoverflow.com/survey/2018]</a>.' }, { text: '&#9656; Thus from <scan style="color:red;font-weight:500;">EandE</scan>\'s Instructional R&D Lab (as based at my home/garage since 2004), I wish to present a portfolio of Industry-Inspired, Curriculum-Based Projects that feature JavaScript and/or Python, along with their respective core API libraries (as noted below).  Below, the aqua-blue buttons link to live demo sites.' }],

      skills_groups: [{
        skills_group_group_name: '<scan style="color:red;font-weight:500;">EandE</scan>\'s Industry-Inspired Curricula',

        skills_group_group_text: null,
        skills_group_name: '&#9656; Web Full-Stack: JavaScript (JS), Python and Their Ecosystem',
        skills_group_text: '&#9656; Following Showcasing Project-Based Core Technologies:',
        skills_group_timePeriod: {
          from: null,
          to: null
        },

        skills: [{
          skill_head: '&#9656; React:',
          skill_body: 'JS Frontend: Apollo, Axios, Enzyme, Express, Gatsby, GraphQL, Jest, MongoDB, Particles.js, Redux',
          skill_link: 'projects-react/',
          skill_link_tab_index: '1',

          skill_childs: [{ text: null }]
        }, {
          skill_head: '&#9656; Vue.js:',
          skill_body: 'JS Frontend: Apollo, Axios, Express, GraphQL, MongoDB, Nuxt, Stripe, SVG Graphics, TweenJs, Vuex',
          skill_link: 'projects-vue-js/',
          skill_link_tab_index: '2',

          skill_childs: [{ text: null }]
        }, {
          skill_head: '&#9656; Node.js:',
          skill_body: 'JS Backend: Axios, Express, MongoDB, Mongoose, Passport, Socket.io, WebSocket',
          skill_link: 'projects-node-js/',
          skill_link_tab_index: '3'
        }, {
          skill_head: '&#9656; Cloud/Server:',
          skill_body: 'Backend: Amazon AWS/EB, Digital Ocean NginX/Apache, Google-Firebase, Heroku, Netlify, Zeit-Now',
          skill_link: null
        }, {
          skill_head: '&#9656; Others:',
          skill_body: 'Python: Bottle, Flask -- JavaScript: Bootstrap, CSS, Highcharts, HTML, JQuery, SQL, Webpack',
          skill_link: null
        }]
      }, {
        skills_group_group_name: null,
        skills_group_group_text: null,
        skills_group_name: '&#9656; Silicon Valley\'s 1st Open-Source, Competition-Grade & Lower-Cost Alternative to LEGO®, TETRIX® & VEX® Robotics',
        skills_group_text: '&#9656; As Showcased at Tech Museum (2014), San Jose -&- Maker Faire\'s Premiere Showroom, Bay Area (2015-2016)<br>' + '&#9656; <span style="font-weight:400"><u>T</u>.<u>A</u>.<u>C</u>.<u>H</u>.nology® Robotics w/ Arduino & Raspberry Pi</span><br>' + '&#9656; Combining "<span style="font-weight:400"><u>T</u>.</span>echnology, <span style="font-weight:400"><u>A</u>.</span>rts & <span style="font-weight:400"><u>C</u>.</span>rafts... <span style="font-weight:400"><u>H</u>.</span>olistically" for Primary, Secondary & Collegiate Ed',
        skills_group_timePeriod: {
          from: null,
          to: null
        },

        skills: [{
          skill_head: '&#9656; Award-Winning Coding Editor:',
          skill_body: 'Google\'s \'Blockly Drag-n-Drop\' Programmer (2016 \'Code for the Kingdom\' 2 Innovative Awards)',
          skill_link: 'projects-robotics/',
          skill_link_tab_index: '4',

          skill_childs: [{ text: '&#9656; S.T.E.A.M. (Science, Tech, Engineering, Arts & Math) Curriculum' }, { text: '&#9656; Web Full-Stack Remote-Control System using Raspberry Pi (JS, Python)' }, { text: '&#9656; Designed for M.assively E.ngaged C.o-op C.ompetition (M.E.C.C.®) Events' }, { text: '&#9656; More info on T.A.C.H.nology® Robotics at <scan style="color:red;font-weight:500;">EandE</scan>\'s Main Site: <a href="http://www.eande.world" class="skillUrl" target="_blank" style="color:blue;text-decoration-line:underline;font-size:100%">http://www.EandE.world</a>' }]
        }]
      }, {
        skills_group_group_name: null,
        skills_group_group_text: null,
        skills_group_name: '&#9656; Other Robotics Taught',
        skills_group_text: null,
        skills_group_timePeriod: {
          from: null,
          to: null
        },

        skills: [{
          skill_head: '&#9656; Lego EV3/NXT2',
          skill_body: null,
          skill_link: null,
          skill_link_tab_index: null,

          skill_childs: [{ text: '&#9656; 1st & Top 5 Overall: Single-Sonar Line-Tracking at RoboGame Jr., Coach (<scan style="color:red;font-weight:500;">EandE</scan>, 2012 & 2013)' }]
        }, {
          skill_head: '&#9656; FTC Tetrix',
          skill_body: null,
          skill_link: null,
          skill_link_tab_index: null,

          skill_childs: [{ text: '&#9656; 1st: First Tech Challenge (FTC) Regionals, Software Coach (King\'s Academy Robotics, Sunnyvale, 2016)' }]
        }]
      }, {
        skills_group_group_name: '<scan style="color:red;font-weight:500;">EandE</scan>\'s Industry-Inspired Teaching',
        skills_group_group_text: null,
        skills_group_name: '&#9656; "Paid Teaching-Sabbatical" as Interim Web Full-Stack Developer',
        skills_group_text: 'Siemens-eMeter, Foster City, CA',
        skills_group_timePeriod: {
          from: 'Jan 2017',
          to: 'Dec 2017'
        },
        skills_group_ageRange: 'Industry',

        skills: [{
          skill_head: '&#9656; Full-Stack Web Demo:',
          skill_body: 'JavaScript & Python Server/Client Programming for their Energy Smart-Grid Prototype',
          skill_link: 'projects-robotics/',
          skill_link_tab_index: '4',

          skill_childs: [{ text: '&#9656; 1-Year Contract to provide <scan style="color:red;font-weight:500;">EandE</scan>\'s Web Full-Stack T.A.C.H.nology® for their Cloud-Based System' }]
        }]
      }, {
        skills_group_group_name: null,
        skills_group_group_text: null,
        skills_group_name: '&#9656; Adjunct Professor, Computer Science and Engineering',
        skills_group_text: 'Cogswell Polytechnical College, San Jose, CA',
        skills_group_timePeriod: {
          from: 'Jan 2017',
          to: 'Apr 2017'
        },
        skills_group_ageRange: 'College',

        skills: [{
          skill_head: '&#9656; CS 110: C Programming',
          skill_body: null,
          skill_link: null,
          skill_link_tab_index: null,

          skill_childs: [{ text: '&#9656; A Fundamental Prerequisite Course.  Though for only one semester, this teaching opportunity serves as a strategic first-step for <scan style="color:red;font-weight:500;">EandE</scan> establishing Collegiate Alliances for Open-Source R&D Collaboration among Staff & Students.' }]
        }]
      }, {
        skills_group_group_name: null,
        skills_group_group_text: null,
        skills_group_name: '&#9656; Computer Science & Robotics Instructor',
        skills_group_text: 'Heart Academy Home-School Co-op, San Jose, CA',
        skills_group_timePeriod: {
          from: 'Aug 2011',
          to: 'May 2017'
        },
        skills_group_ageRange: 'Middle & High School',

        skills: [{
          skill_head: '&#9656; T.A.C.H.nology® Robotics w/ Arduino & Raspberry Pi',
          skill_body: null,
          skill_link: null,
          skill_link_tab_index: null,

          skill_childs: [{ text: '&#9656; Students showcased at Maker Faire\'s Premiere Showroom (2015-2016) and Robotics Showroom (2017), drawing over 100k spectators during the 2-day event (further details of curriculum explained above).' }]
        }, {
          skill_head: '&#9656; Computer Science: “Game-ON Programming-2-Publishing”',
          skill_body: null,
          skill_link: null,
          skill_link_tab_index: null,

          skill_childs: [{ text: '&#9656; Pioneered \'Integrative Dual-Hemispheres Whole-Brain\' Pedagogy (as inspired by Stanford University\'s Research) by Teaching Abstract, Complex Computer-Concepts using Concrete, Intuitive Casual Video-Games (e.g. Flappy Bird) to Engage & Feed the Cognitive/Analytical Side of Learning, while the Entertaining/Competitive Qualities of the Gaming Experience Engages & Stimulates the Affective/Emotive Side of Learning.</a>' }, { text: '&#9656; Python for 3D Minecraft , Lua for Roblox and JavaScript for Construct 2.' }, { text: '&#9656; Flagship Class-Project “Itty Bitty Jr in Mutant Madness" Published on 2 Major App Stores:' }, { text: '&nbsp; &nbsp; &#9656; <a href="https://itunes.apple.com/ee/app/itty-bitty-jr-in-mutant-madness/id946673546?mt=8" class="urlLink" target="_blank" style="color:blue;text-decoration-line: underline;">Apple App Store (iOS)</a>' }, { text: '&nbsp; &nbsp; &#9656; <a href="https://play.google.com/store/apps/details?id=org.EncourageAndEmpower.IttyBittyJrInMutantMadness" class="urlLink" target="_blank" style="color:blue;text-decoration-line: underline;">Google Play (Android)</a>' }, { text: '&#9656; Above Showcased at Maker Faire\'s Young Makers Regionals at S.J.\'s The Tech Museum and S.F.\'s Exploratoriuim.' }]
        }]
      }, {
        skills_group_group_name: null,
        skills_group_group_text: null,
        skills_group_name: '&#9656; Summer Tech Coordinator & Lead Instructor',
        skills_group_text: 'Bayshore Christian Ministries, East Palo Alto, CA',
        skills_group_timePeriod: {
          from: 'Summer 2014 & 2016',
          to: null
        },
        skills_group_ageRange: 'Elementary & Middle School',

        skills: [{
          skill_head: '&#9656; Programming & Robotics',
          skill_body: null,
          skill_link: null,
          skill_link_tab_index: null,

          skill_childs: [{ text: '&#9656; After Volunteer-Teaching for 6 Summers in their Youth Programs, Served as Technology Coordinator & Lead Instructor for 4-Week Summer Camps serving Inner-City Kids regarding:' }, { text: '&#9656;&#9656; Programming: Visual-Coding in Scratch 2.0 by M.I.T. -&- Code Studio by Code.org.' }, { text: '&#9656;&#9656; Robotics: Lego NXT2 Robotics.' }, { text: '&#9656; Trained and Supervised a Team of Instructors and Assistants.' }]
        }]
      }, {
        skills_group_group_name: null,
        skills_group_group_text: null,
        skills_group_name: '&#9656; Private Tutor',
        skills_group_text: '<scan style="color:red;font-weight:500;">EandE</scan>, Milpitas, CA',
        skills_group_timePeriod: {
          from: 'Fall 2006',
          to: 'Jul 2011'
        },
        skills_group_ageRange: 'Middle & High School',

        skills: [{
          skill_head: '&#9656; SAT Math, AP Calculus AB, Algebra 1 & 2, Geometry, Trigonometry & Middle School Math',
          skill_body: null,
          skill_link: null,
          skill_link_tab_index: null,

          skill_childs: [{ text: null }]
        }]
      }]
    }, {
      job_group_name: 'Teaching Experiences #2 to #5',
      job_group_text: null,
      job_title: 'Director & Associate Pastor of Youth/Family Ministries',
      job_company: 'South Bay Chinese Gospel Church',
      job_location: 'Fremont, CA',
      job_url: null,
      job_timePeriod: {
        from: 'Aug 2004',
        to: 'Sep 2014'
      },
      job_ageRange: 'Middle & High School',

      job_childs: [{ text: '&#9656; Large-Scale Speaker for Family Chapel Services (100+ attendance), Family Retreats (50+) & Jr./Sr. High Outreaches (30+).' }, { text: '&#9656; Conducted Workshops to help Immigrant Asian-Parents Bridge Generation & Cultural Gap with Americanized Children.' }]
    }, {
      job_group_name: null,
      job_group_text: null,
      job_title: 'Multiple-Subject Instructor',
      job_company: 'Sylvan Learning Center',
      job_location: 'Fremont, CA',
      job_url: null,
      job_timePeriod: {
        from: 'Apr 2003 ',
        to: 'May 2008'
      },
      job_ageRange: 'Middle & High School',
      job_childs: [{ text: '&#9656; Instructor for Reading, Writing & Math, achieving the highest recognition of “Preferred Status” with Students & Parents.' }, { text: '&#9656; SAT Prep in Mathematics for High School Students. ' }]
    }, {
      job_group_name: null,
      job_group_text: null,
      job_title: 'Intern Pastoral Ministries ',
      job_company: 'Grace Community Covenant Church (Asian-American Focus)',
      job_location: 'Los Altos, CA',
      job_url: null,
      job_timePeriod: {
        from: 'Mar 2003 ',
        to: 'Apr 2004'
      },
      job_ageRange: 'Children & Families',
      job_childs: [{ text: '&#9656; Communicated vision, recruited and trained staff, and researched curriculum tools for the implementation of an Inter-Generational Sunday Worship Service.' }]
    }, {
      job_group_name: null,
      job_group_text: null,
      job_title: 'California-Credentialed Math Teacher',
      job_company: 'John Muir Middle School',
      job_location: 'San Leandro, CA',
      job_url: null,
      job_timePeriod: {
        from: 'Sep 1995',
        to: 'Jun 1996'
      },
      job_ageRange: 'Middle School',
      job_childs: [{ text: '&#9656; Five classes totaling over 125 students/day: three mainstream 7th grades, one sheltered 7th grade, and one mainstream 6th grade using Prentice Hall Middle Grade Courses 1 & 2.' }, { text: '&#9656; Reason for Leaving: Though approved for renewal to continue teaching at John Muir Middle, personally felt the need for higher training to be better equipped to serve our local community.  Thus enrolled into Western Seminary Masters program (see \'Education\' above).' }],
      skills_groups: [{
        skills_group_group_name: null,

        skills_group_group_text: null,
        skills_group_name: null,
        skills_group_text: null,
        skills_group_timePeriod: {
          from: null,
          to: null
        },

        skills: [{
          skill_head: null,
          skill_body: null,
          skill_link: null,
          skill_link_tab_index: null,

          skill_childs: [{ text: null }]
        }]
      }]
    }, {
      job_group_name: 'Industry Experience #1 to #2',
      job_group_text: null,
      job_title: 'Firmware Engineer for Embedded x86 Linux',
      job_company: 'San Valley Systems',
      job_location: 'San Jose, CA',
      job_url: null,
      job_timePeriod: {
        from: 'Jan 2001 ',
        to: 'Sep 2002'
      },
      job_childs: [{ text: '&#9656; Network TCP/IP Traffic & Route Diagnostics for Fibre Channel FCIP; Firmware & ASIC Co-Simulation Verification; Brocade and Ancor FC-Switch Systems Analysis.' }, { text: '&#9656; Reason for Leaving: This served as an interim position, while seekeing a teaching position -- that later being an Intern position at Grace Community Covenant Church. (see \'Teaching Experience\' above).' }],
      skills_groups: [{
        skills_group_group_name: null,

        skills_group_group_text: null,
        skills_group_name: null,
        skills_group_text: null,
        skills_group_timePeriod: {
          from: null,
          to: null
        },

        skills: [{
          skill_head: null,
          skill_body: null,
          skill_link: null,
          skill_link_tab_index: null,

          skill_childs: [{ text: null }]
        }]
      }]
    }, {
      job_group_name: null,
      job_group_text: null,
      job_title: 'Software Engineer',
      job_company: 'Loral Space & Range Systems',
      job_location: 'Sunnyvale, CA',
      job_url: null,
      job_timePeriod: {
        from: 'Aug 1988',
        to: 'Jun 1994'
      },
      job_childs: [{ text: '&#9656; Implemented FoxPro Relational Database for Satellite Tracking Operations; Integrated C and C++ modules for Database Analysis.' }, { text: '&#9656; Reason for Leaving: Though work has been an extremely positive experience, personally felt inspired to work more directly with people -- especially after volunteering over 6 years teaching and mentoring youths in my local community.  Thus, enrolled into Mills College for the Teacher Credentialing program. (see \'Education\' above).' }],
      skills_groups: [{
        skills_group_group_name: null,

        skills_group_group_text: null,
        skills_group_name: null,
        skills_group_text: null,
        skills_group_timePeriod: {
          from: null,
          to: null
        },

        skills: [{
          skill_head: null,
          skill_body: null,
          skill_link: null,
          skill_link_tab_index: null,

          skill_childs: [{ text: null }]
        }]
      }]
    }, {
      job_group_name: 'References Available Upon Request',
      job_group_text: null,
      job_title: null,
      job_company: null,
      job_location: null,
      job_url: null,
      job_timePeriod: {
        from: null,
        to: null
      },
      job_childs: [{ text: null }]
    }],
    projects: [{
      category: 'react-dir',
      id: 0,
      imageListLength: 1,
      slug: '53c-03d-03d-BurgerBuilderPlus',
      title: 'Burger Builder Plus',
      headLine00: 'Fast-Food Order App: Burger Builder Plus',
      headLine01: 'React, Axios, Redux, Enzyme, Jest',
      headLine02: 'Google-Firebase',
      url: 'https://myburger-react-maxs.firebaseapp.com',
      description: 'Description'
    }, {
      category: 'react-dir',
      id: 0,
      imageListLength: 1,
      slug: '53ka-BlogPlus',
      title: 'Blog Plus',
      headLine00: 'Blog App: Full-Stack Web Dev',
      headLine01: 'React, Gatsby, GraphQL, Particles.js (Animation), Jest',
      headLine02: 'Netlify',
      url: 'https://react-gatsby-blog-dustinc.netlify.com',
      description: 'Description'
    }, {
      category: 'react-dir',
      id: 0,
      imageListLength: 1,
      slug: '53p-CatchOfTheDayPlus',
      title: 'Catch of the Day Plus',
      headLine00: 'Seafood Order & Inventory App: Catch of the Day Plus',
      headLine01: 'React, CRUD (Firebase-Google), Authentication (GitHub, Twitter, FaceBook)',
      headLine02: 'Netlify',
      url: 'http://react-catchoftheday-wesbos.netlify.com/',
      description: 'Description'
    }, {
      category: 'react-dir',
      id: 0,
      imageListLength: 1,
      slug: '37e-BookshopPlus',
      title: 'BookShop Plus',
      headLine00: 'Bookstore Order & Admin App: BookShop Plus',
      headLine01: 'Mondo, Express, React & Node (MERN)',
      headLine02: 'Amazon ~ Elastic Beanstalk (EB)',
      url: 'http://react-bookshop-marco-tomasello.nyu2gnsj37.us-west-1.elasticbeanstalk.com/',
      description: 'Description'
    }, {
      category: 'vuejs-dir',
      id: 0,
      imageListLength: 1,
      slug: '38c-ShoppityPlus',
      title: 'Shoppity Plus',
      headLine00: 'Clothing Store w/ Credit Card Purchasing: Shoppity Plus',
      headLine01: 'Vue, Nuxt, Vuex, Stripe (Credit Card Purchasing)',
      headLine02: 'Netlify',
      url: 'https://vuejs-shoppityplus-sarahdrasner.netlify.com/',
      description: 'Description'
    }, {
      category: 'vuejs-dir',
      id: 0,
      imageListLength: 1,
      slug: '38b-PizzaPlanetPlus',
      title: 'Pizza Planet Plus',
      headLine00: 'Pizza Order & Admin App: Pizza Planet Plus',
      headLine01: 'Vue, Vuex, Google-Firebase (Database), Authentication (Email/Password)',
      headLine02: 'Digital Ocean ~ Linux Ubuntu',
      url: 'http://138.68.57.214:8081/',
      description: 'Description'
    }, {
      category: 'vuejs-dir',
      id: 0,
      imageListLength: 1,
      slug: '73c-03f-CooperaPlus',
      title: 'Coopera Plus',
      headLine00: 'Multi-Player Web-Based Game: Coopera Plus',
      headLine01: 'Vue, Socket.io, WebSocket',
      headLine02: 'Digital Ocean ~ Linux Ubuntu',
      url: 'http://138.68.57.214:8082/',
      description: 'Description'
    }, {
      category: 'vuejs-dir',
      id: 0,
      imageListLength: 1,
      slug: '37q-03f-CastleDuelPlus',
      title: 'Castle Duel Plus',
      headLine00: 'Animation-Based Game: Castle Duel Plus',
      headLine01: 'Vue : SVG Grapics, TweenJs (Animation)',
      headLine02: 'Digital Ocean ~ Linux Ubuntu',
      url: 'https://jasonc1025.github.io/VueJs-CastleDuel-GuillaumeC/ ',
      description: 'Description'
    }, {
      category: 'vuejs-dir',
      id: 0,
      imageListLength: 1,
      slug: '37j-Sec18-StockTraderPlus',
      title: 'Stock Trader Plus',
      headLine00: 'Stock-Trading Simulation Game: Stock Trader Plus',
      headLine01: 'Vue, Vuex, Bootstrap',
      headLine02: 'Amazon S3; Digital Ocean ~ NginX',
      url: 'http://stocktrader-vuejs-maxs.s3-website-us-west-1.amazonaws.com/',
      description: 'Description'
    }, {
      category: 'nodejs-dir',
      id: 0,
      imageListLength: 1,
      slug: '37l-DangThatsDeliciousPlus',
      title: 'Now That\'s Delicious Plus',
      headLine00: 'Favorite Store Map & Review App: Now That\'s Delicious',
      headLine01: 'Node, Axios, Express, MongoDB, Mongoose, Passport',
      headLine02: 'Heroku; Now-Zeit',
      url: 'https://dang-thats-delicious-jwc.herokuapp.com/',
      description: 'Description'
    }, {
      category: 'nodejs-dir',
      id: 0,
      imageListLength: 1,
      slug: '17-10g-ObsidioPlus',
      title: 'Obsidio Plus',
      headLine00: 'Multi-Player Web-Based Game: Obsidio Plus',
      headLine01: 'Node, Express, Socket.io',
      headLine02: 'Heroku',
      url: 'https://obsidio-alvin-l.herokuapp.com/',
      description: 'Description'
    }, {
      category: 'robotics-dir',
      id: 0,
      imageListLength: 1,
      slug: '11h-ArduBlockly-EandE',
      title: 'ArduBlockly-EandE',
      headLine00: '* x2 AWARD-WINNING Coding Editor * Google\'s \'Drag-n-Drop\' w/ C++ Visual-Translation for our T.A.C.H.nology® Robotics',
      headLine01: 'Node, Google-Blockly, Electron',
      headLine02: 'Python Bottle & Digital Ocean ~ Ubuntu',
      url: 'http://138.68.57.214:8001/ardublockly/index.html',
      description: 'Description'
    }, {
      category: 'robotics-dir',
      id: 0,
      imageListLength: 1,
      slug: 'EandE-TACHnology-Website',
      title: 'T.A.C.H.nology® Robotics',
      headLine00: 'T.A.C.H.nology® Robotics: Silicon Valley\'s 1st Open-Source, Competition-Grade & Lower-Cost Alternative to LEGO®, TETRIX® & VEX® Systems',
      headLine01: '',
      headLine02: '',
      url: 'http://www.eande.world/',
      description: 'Description'
    }, {
      category: 'industry-siemens-dir',
      id: 0,
      imageListLength: 1,
      slug: 'Siemens-PTI-PSSE',
      title: 'SMART-GRID SIMULATION',
      headLine00: '* SMART-GRID SIMULATION * Siemens User-Experience (UX) Prototype: Power System Simulator',
      headLine01: 'JavaScript, jQuery, jQWidgets, HTML, CSS',
      headLine02: 'Python-SocketServer.TCPServer, Python-SimpleHTTPServer',

      url: '',
      description: 'Description'
    }, {
      category: 'industry-siemens-dir',
      id: 0,
      imageListLength: 1,
      slug: 'Siemens-CIPortal-ThreeAmigoes',
      title: 'SMART-GRID UI/UX',
      headLine00: '* SMART-GRID UI/UX * Siemens User-Experience (UX) Prototype: Energy IP ~ C&I Portal',
      headLine01: 'JavaScript, Highcharts, HTML, CSS',
      headLine02: 'Netlify',

      url: '',
      description: 'Description'
    }, {
      category: 'industry-siemens-dir',
      id: 0,
      imageListLength: 1,
      slug: 'Siemens-EnergyIP-SDPAnalyzer-DemsPortal',
      title: 'BIG DATA - ANALYTICS',
      headLine00: '* BIG DATA - ANALYTICS * Siemens User-Experience (UX) Prototype: Energy IP ~ DEMS Portal',
      headLine01: 'JavaScript, Highcharts, HTML, CSS',
      headLine02: 'Netlify',

      url: '',
      description: 'Description'
    }]
  }
}));

/***/ }),
/* 40 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_MainNav__ = __webpack_require__(104);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_MainNav___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_MainNav__);




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'appComponent',
  components: {
    mainNavComponent: __WEBPACK_IMPORTED_MODULE_0__components_MainNav___default.a
  },
  data: function data() {
    return {
      currentYear: new Date().getFullYear(),

      fontSize: 16,

      fontSizeChange_00_Style: {
        fontWeight: '300',
        color: 'red'
      },
      fontSizeChange_01_Style: {
        color: '#ccc' }

    };
  }
});

/***/ }),
/* 41 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'error'
});

/***/ }),
/* 42 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'HomeComponent',
  data: function data() {
    return {
      jobs: this.$myStore.state.jobs,
      tabMode: this.$myStore.state.tabMode,
      store: this.$myStore,


      items_Stage00: [{
        title: 'Whether as an Software Engineer...',
        msg: '',
        itemsSub: [{ text: 'With <scan style="font-weight:500;">Dual-Empahsis</scan> in <scan style="font-weight:500;">both Software and Hardware Engineering</scan> as an Electrical and Computer Engineering Major at <scan style="font-weight:500;">U.C. Davis</scan>' }, { text: 'and Combined <scan style="font-weight:500;">15+ years</scan> in Engineering,' }, { text: 'I specialize in <scan style="font-weight:500;">both Web Full-Stack (Software) and Robotics (Software & Hardware) Development</scan>.' }]
      }, {
        title: '...Or as a Teacher for Software / Hardware Engineering,...',
        msg: '',
        itemsSub: [{ text: 'With <scan style="font-weight:500;">Professional Training</scan> as a <scan style="font-weight:500;">Teacher, Speaker and Communicator</scan> from <scan style="font-weight:500;">both Mills College\'s Math & Science Teaching </scan> (CA State Teacher Credential) and <scan style="font-weight:500;">Western Seminary\'s Master of Arts</scan> (Homiletics\' Top Honors) <scan style="font-weight:500;">Programs</scan>' }, { text: 'and Cummulative <scan style="font-weight:500;">10+ years</scan> in Public & Private School Teaching,' }, { text: 'I enjoy <scan style="font-weight:500;">encouraging and empowering People through Teaching</scan>.' }]
      }, {
        title: '...I seek to Serve in either One of the above Two Occupations.',
        msg: '',
        itemsSub: [{ text: 'Kindly Preview the above Tabs for Resum&eacute;, Vision and Showcase Projects.' }]
      }]
    };
  }
});

/***/ }),
/* 43 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'mainNav',
  data: function data() {
    return {
      tabMode: this.$myStore.state.tabMode,
      store: this.$myStore
    };
  },

  methods: {
    greet: function greet(event) {
      console.log('this.tabMode: ' + this.tabMode);
      console.log('this.$myStore.state.tabMode: ' + this.$myStore.state.tabMode);
      console.log('');
    }
  }
});

/***/ }),
/* 44 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Error__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Error___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__Error__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_in_view__ = __webpack_require__(100);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_in_view___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_in_view__);






/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'project',
  components: {
    Error: __WEBPACK_IMPORTED_MODULE_1__Error___default.a
  },
  data: function data() {
    return {
      project: {},
      previousProject: {},
      nextProject: {}
    };
  },

  methods: {
    clearLoaded: function clearLoaded() {
      var list = document.querySelectorAll('.lazy.loaded');
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(list), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var item = _step.value;

          item.classList.remove('loaded');
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }
    },
    getProjects: function getProjects() {
      var _this = this;

      var result = this.$myStore.state.projects.filter(function (obj) {
        return obj.slug === _this.$route.params.slug;
      });

      if (result.length) {
        if (result[0].category === this.$route.params.category) {
          this.project = result[0];
          this.getPreviousProject();
          this.getNextProject();
        }
      }
    },
    getPreviousProject: function getPreviousProject() {
      var _this2 = this;

      var result = this.$myStore.state.projects.filter(function (obj) {
        return obj.id === _this2.project.id - 1;
      });

      if (result.length) {
        this.previousProject = result[0];
      } else {
        this.previousProject = {};
      }
    },
    getNextProject: function getNextProject() {
      var _this3 = this;

      var result = this.$myStore.state.projects.filter(function (obj) {
        return obj.id === _this3.project.id + 1;
      });

      if (result.length) {
        this.nextProject = result[0];
      } else {
        this.nextProject = {};
      }
    },
    projectNav: function projectNav() {
      var nav = document.querySelector('.project nav');

      __WEBPACK_IMPORTED_MODULE_2_in_view___default()('.project .details').on('enter', function (el) {
        nav.classList.remove('visible');
      }).on('exit', function (el) {
        nav.classList.add('visible');
      });
      __WEBPACK_IMPORTED_MODULE_2_in_view___default.a.offset(-50);
    }
  },
  beforeMount: function beforeMount() {
    this.getProjects();
  },
  beforeUpdate: function beforeUpdate() {
    this.clearLoaded();
  },
  mounted: function mounted() {
    this.projectNav();
  },

  watch: {
    '$route.params.slug': function $routeParamsSlug() {
      this.getProjects();
    }
  }
});

/***/ }),
/* 45 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'ResumeComponent',
  data: function data() {
    return {
      jobs: this.$myStore.state.jobs,
      tabMode: this.$myStore.state.tabMode,
      store: this.$myStore,

      items_Stage00: [{
        title: 'How are you?',

        msg: 'Test for fun! asjdf kasjfd;l a;skdfja;sljdfksadj ;fljas lk;fj sak;lfj las;kj f;klasdj f;kasjdkfl;ajs dfjsa akdsf<br>Line2abc<br>Line3',
        itemsSub: [{ text: 'test1<br>test1.1<br>test1.2' }, { text: 'test2<br>test2.1<br>test2.2' }, { text: 'test3<br>test3.1<br>test3.2' }]
      }, {
        title: 'Who let the dog out?',
        msg: 'I do not know, dude.',
        itemsSub: [{ text: 'test1a<br>test1.1<br>test1.2' }, { text: 'test2a<br>test2.1<br>test2.2' }, { text: 'test3a<br>test3.1<br>test3.2' }]
      }, {
        title: '肚子好餓?',
        msg: '吃芭樂啦！',
        itemsSub: [{ text: 'test1b<br>test1.1<br>test1.2' }, { text: 'test2b<br>test2.1<br>test2.2' }, { text: 'test3b<br>test3.1<br>test3.2' }]
      }, {
        title: 'Find hotels?',
        msg: 'Trivago！',
        itemsSub: [{ text: 'test1c<br>test1.1<br>test1.2' }, { text: 'test2c<br>test2.1<br>test2.2' }, { text: 'test3c<br>test3.1<br>test3.2' }]
      }]
    };
  }
});

/***/ }),
/* 46 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'ResumeComponent',
  data: function data() {
    return {
      jobs: this.$myStore.state.jobs,
      tabMode: this.$myStore.state.tabMode,
      store: this.$myStore,

      items_Stage00: [{
        title: 'How are you?',

        msg: 'Test for fun! asjdf kasjfd;l a;skdfja;sljdfksadj ;fljas lk;fj sak;lfj las;kj f;klasdj f;kasjdkfl;ajs dfjsa akdsf<br>Line2abc<br>Line3',
        itemsSub: [{ text: 'test1<br>test1.1<br>test1.2' }, { text: 'test2<br>test2.1<br>test2.2' }, { text: 'test3<br>test3.1<br>test3.2' }]
      }, {
        title: 'Who let the dog out?',
        msg: 'I do not know, dude.',
        itemsSub: [{ text: 'test1a<br>test1.1<br>test1.2' }, { text: 'test2a<br>test2.1<br>test2.2' }, { text: 'test3a<br>test3.1<br>test3.2' }]
      }, {
        title: '肚子好餓?',
        msg: '吃芭樂啦！',
        itemsSub: [{ text: 'test1b<br>test1.1<br>test1.2' }, { text: 'test2b<br>test2.1<br>test2.2' }, { text: 'test3b<br>test3.1<br>test3.2' }]
      }, {
        title: 'Find hotels?',
        msg: 'Trivago！',
        itemsSub: [{ text: 'test1c<br>test1.1<br>test1.2' }, { text: 'test2c<br>test2.1<br>test2.2' }, { text: 'test3c<br>test3.1<br>test3.2' }]
      }]
    };
  }
});

/***/ }),
/* 47 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'VisionComponent',
  data: function data() {
    return {
      jobs: this.$myStore.state.jobs,
      tabMode: this.$myStore.state.tabMode,
      store: this.$myStore
    };
  }
});

/***/ }),
/* 48 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'WorkComponent',
  data: function data() {
    return {
      projects: this.$myStore.state.projects
    };
  }
});

/***/ }),
/* 49 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'WorkIndustrySiemensComponent',
  data: function data() {
    return {
      projects: this.$myStore.state.projects,
      projectCategory: 'industry-siemens-dir'
    };
  }
});

/***/ }),
/* 50 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'WorkNodeJsComponent',
  data: function data() {
    return {
      projects: this.$myStore.state.projects,
      projectCategory: 'nodejs-dir'
    };
  }
});

/***/ }),
/* 51 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'WorkReactComponent',
  data: function data() {
    return {
      projects: this.$myStore.state.projects,
      projectCategory: 'react-dir'
    };
  }
});

/***/ }),
/* 52 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'WorkRoboticsComponent',
  data: function data() {
    return {
      projects: this.$myStore.state.projects,
      projectCategory: 'robotics-dir'
    };
  }
});

/***/ }),
/* 53 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'WorkVueJsComponent',
  data: function data() {
    return {
      projects: this.$myStore.state.projects,
      projectCategory: 'vuejs-dir'
    };
  }
});

/***/ }),
/* 54 */,
/* 55 */,
/* 56 */,
/* 57 */,
/* 58 */,
/* 59 */,
/* 60 */,
/* 61 */,
/* 62 */,
/* 63 */,
/* 64 */,
/* 65 */,
/* 66 */,
/* 67 */,
/* 68 */,
/* 69 */,
/* 70 */,
/* 71 */,
/* 72 */,
/* 73 */,
/* 74 */,
/* 75 */,
/* 76 */,
/* 77 */,
/* 78 */,
/* 79 */,
/* 80 */,
/* 81 */,
/* 82 */,
/* 83 */,
/* 84 */,
/* 85 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 86 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 87 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 88 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 89 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 90 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 91 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 92 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 93 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 94 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 95 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 96 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 97 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 98 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 99 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 100 */,
/* 101 */,
/* 102 */,
/* 103 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(89)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(42),
  /* template */
  __webpack_require__(118),
  /* scopeId */
  "data-v-33658cc4",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 104 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(93)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(43),
  /* template */
  __webpack_require__(122),
  /* scopeId */
  "data-v-600eb98a",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 105 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(94)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(44),
  /* template */
  __webpack_require__(123),
  /* scopeId */
  "data-v-6599fa2a",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 106 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(95)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(45),
  /* template */
  __webpack_require__(124),
  /* scopeId */
  "data-v-7033e82c",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 107 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(99)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(46),
  /* template */
  __webpack_require__(128),
  /* scopeId */
  "data-v-f42e4040",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 108 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(87)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(47),
  /* template */
  __webpack_require__(116),
  /* scopeId */
  "data-v-1b892667",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 109 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(86)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(48),
  /* template */
  __webpack_require__(115),
  /* scopeId */
  "data-v-055ba2d0",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 110 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(97)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(49),
  /* template */
  __webpack_require__(126),
  /* scopeId */
  "data-v-7aeadf2e",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 111 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(88)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(50),
  /* template */
  __webpack_require__(117),
  /* scopeId */
  "data-v-1bb7465b",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 112 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(96)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(51),
  /* template */
  __webpack_require__(125),
  /* scopeId */
  "data-v-776f7182",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 113 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(92)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(52),
  /* template */
  __webpack_require__(121),
  /* scopeId */
  "data-v-5ff8cb5f",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 114 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(90)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(53),
  /* template */
  __webpack_require__(119),
  /* scopeId */
  "data-v-3c4e7f2f",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 115 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "divStyle"
  }, [_c('ul', {
    staticClass: "ulStyle"
  }, _vm._l((_vm.projects), function(project) {
    return _c('li', [_c('a', {
      staticClass: "button",
      attrs: {
        "target": "_blank",
        "href": project.url
      }
    }, [_c('h3', [_vm._v("Press to Enter Demo Site: "), _c('br'), _vm._v(" " + _vm._s(project.title) + " "), _c('br'), _vm._v(" " + _vm._s(project.title02))]), _vm._v(" "), _c('h1', [_vm._v(" " + _vm._s(project.headerLine00) + " ")]), _vm._v(" "), _c('h2', [_vm._v(" • Front-End: "), _c('b', [_vm._v(" " + _vm._s(project.headerLine01) + " ")])]), _vm._v(" "), _c('h2', [_vm._v(" • Back-End: "), _c('b', [_vm._v(" " + _vm._s(project.headerLine02) + " ")])]), _vm._v(" "), _c('div', {
      staticClass: "imageContainer lazy"
    }, [_c('img', {
      directives: [{
        name: "lazy",
        rawName: "v-lazy",
        value: (("/static/work/" + (project.category) + "/" + (project.slug) + "/" + (project.slug) + "_thumb.png")),
        expression: "`/static/work/${project.category}/${project.slug}/${project.slug}_thumb.png`"
      }],
      attrs: {
        "data-srcset": ("/static/work/" + (project.category) + "/" + (project.slug) + "/" + (project.slug) + "_thumb.png")
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "spinner"
    })])])])
  }))])
},staticRenderFns: []}

/***/ }),
/* 116 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "visionStyle"
  }, [_vm._m(0), _vm._v(" "), _c('ul', {
    staticStyle: {
      "list-style": "disc"
    }
  }, [_c('li', [_vm._v("Since "), _c('scanBold', [_vm._v("Co-Founding")]), _vm._v(" an "), _c('scanBold', [_vm._v("Educational-Tech R&D Center")]), _vm._v(" -- "), _c('a', {
    staticClass: "urlLink",
    staticStyle: {
      "color": "blue",
      "text-decoration-line": "underline",
      "font-size": "100%"
    },
    attrs: {
      "href": "http://www.eande.world/",
      "target": "_blank"
    }
  }, [_vm._v("Encourage and Empower (EandE)")]), _vm._v(" -- in 2004 at my home/garage, I've enjoyed serving as "), _c('scanBold', [_vm._v("Sr. Instructor and Curriculum-Engineer")]), _vm._v(" where we developed "), _c('scanBold', [_vm._v("\"T.A.C.H.nology® Robotics w/ Arduino & Raspberry Pi\"")]), _vm._v(" as Silicon Valley's 1st Open-Source, Competition-Grade & Lower-Cost Alternative to LEGO®, TETRIX® & VEX® Robotics.")], 1), _vm._v(" "), _c('li', [_c('scanBold', [_vm._v("Innovations")]), _vm._v(" behind our Educational Robotics System include (more details, photos and short videos can be found at "), _c('a', {
    staticClass: "urlLink",
    staticStyle: {
      "color": "blue",
      "text-decoration-line": "underline",
      "font-size": "100%"
    },
    attrs: {
      "href": "http://www.eande.world/",
      "target": "_blank"
    }
  }, [_vm._v("EandE")]), _vm._v("):\n      "), _c('ul', {
    staticStyle: {
      "list-style": "disc",
      "margin-left": "2em"
    }
  }, [_c('li', [_vm._v("Creative S.T.E.A.M.-Based Hardware-Chassis that integrates \"T.echnology, A.rts & C.rafts... H.olistically\" to inspire Industry-Grade Robotics to both Primary & Secondary School students, as showcased at "), _c('scanBold', [_vm._v("San Jose's Tech Museum and Bay Area's Maker Faire Premier Showroom")]), _vm._v(" (campus attracted 100k+ spectators),")], 1), _vm._v(" "), _c('li', [_vm._v("Industry-Leading Cloud-Based Raspberry-Pi Remote-Control System (Python & C++) that helped lead to a "), _c('scanBold', [_vm._v("1-year alliance with Siemens-eMeter in Foster City")]), _vm._v(" to collaborate on Web Full-Stack Technologies (JavaScript & Python) for their Cloud-Based Energy Smart-Grids, and")], 1), _vm._v(" "), _c('li', [_vm._v("Award-Winning Google-Based 'Blockly Drag-n-Drop' C++ Coding Editor (JavaScript & Python) that opened an opportunity to serve as "), _c('scanBold', [_vm._v("Adjunct Professor for CS110 'C 'Programming at Cogswell Polytechnical College in San Jose")]), _vm._v(".")], 1)])], 1), _vm._v(" "), _c('li', [_vm._v("These above experiences have inspired my R&D efforts at EandE to form the following "), _c('scanBold', [_vm._v("Vision to Encourage and Empower")]), _vm._v(" our students regarding the "), _c('scanBold', [_vm._v("#1 Hi-Tech Career Path… Web/Cloud Development "), _c('scanSlideRef', [_vm._v("(refer below to Slide #1)")])], 1), _vm._v(".")], 1)]), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('ul', {
    staticStyle: {
      "list-style": "disc"
    }
  }, [_c('li', [_vm._v("As "), _c('scanBold', [_vm._v("Open-Source Web/Cloud Technologies")]), _vm._v(" mature and become more mainstreamed into industry, students in Computer Science  -- especially for Colleges and Secondary Schools with limited resources -- are more freed from the previous struggle of playing 'catch-up' to a once 'closed-source, limited-access & high-cost' Hi-Tech field of the past.")], 1), _vm._v(" "), _c('li', [_vm._v("And by properly harnessing this global "), _c('scanBold', [_vm._v("Open-Source Revolution")]), _vm._v(", students can 1) be empowered to innovate with the 'best-of-the-best' world-wide -- regardless of age or socio-economic background -- and subsequently 2) be encouraged to give back to society through "), _c('scanBold', [_vm._v("Open-Source Collaboration")]), _vm._v(".")], 1), _vm._v(" "), _c('li', [_vm._v("Thus our students do not passively-settle as 'industry-learners' -- but rather -- actively-contribute as 'industry-innovators' in responsibly building a stronger community... for life.")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('li', [_vm._v("Traditionally, I've enjoyed coding and teaching "), _c('scanBold', [_vm._v("Java, C#, C++ & C")]), _vm._v(" -- among many other Linux-Based languages/toolsets.")], 1), _vm._v(" "), _c('li', [_vm._v("Yet due to the global pervasiveness of Web/Cloud-Services and Robotics, Stack Overflow's 2018 Global Survey of 100K Developers concludes that two Open-Source Languages -- "), _c('scanBold', [_vm._v("JavaScript")]), _vm._v(" and "), _c('scanBold', [_vm._v("Python")]), _vm._v(" -- have taken our world by 'storm', at least for these past several years "), _c('scanSlideRef', [_vm._v("(Slide #2)")]), _vm._v(".")], 1), _vm._v(" "), _c('li', [_vm._v("Thus from our "), _c('a', {
    staticClass: "urlLink",
    staticStyle: {
      "color": "blue",
      "text-decoration-line": "underline",
      "font-size": "100%"
    },
    attrs: {
      "href": "http://www.eande.world/",
      "target": "_blank"
    }
  }, [_vm._v("Encourage and Empower's (EandE) Instructional R&D Lab")]), _vm._v("  (as based at my home/garage since 2004), I wish to present this "), _c('scanBold', [_vm._v("Online Portfolio")]), _vm._v(" of "), _c('scanBold', [_vm._v("JavaScript & Python Curriculum-Based Projects")]), _vm._v(" to spark our "), _c('scanBold', [_vm._v("Student's Innovation")]), _vm._v(" within the "), _c('scanBold', [_vm._v("Open-Source Global-Ecosystem")]), _vm._v(".")], 1), _vm._v(" "), _c('br'), _vm._v(" "), _c('li', [_vm._v("And with regards to the "), _c('scanBold', [_vm._v("Most Popular Ecosystem: JavaScript")]), _vm._v(" "), _c('scanSlideRef', [_vm._v("(Slide #2)")]), _vm._v(", the following Web/Cloud Technologies are showcased:\n      "), _c('ul', {
    staticStyle: {
      "list-style": "disc",
      "margin-left": "2em"
    }
  }, [_c('li', [_vm._v("Front-end: "), _c('scanBold', [_vm._v("React")]), _vm._v(" and "), _c('scanBold', [_vm._v("Vue.js")]), _vm._v(" as Top 2 Frameworks in Popularity "), _c('scanSlideRef', [_vm._v("(Slides #3, #4 & #5).")])], 1), _vm._v(" "), _c('li', [_vm._v("Back-end: "), _c('scanBold', [_vm._v("Node.js")]), _vm._v(" as Industry's #1 De Facto Standard "), _c('scanSlideRef', [_vm._v("(Slide #6)")]), _vm._v(".")], 1)])], 1)]), _vm._v(" "), _c('h1', [_vm._v("World-Wide Software Development Trends:")]), _vm._v(" "), _c('carousel', {
    attrs: {
      "perPage": 1,
      "autoplay": true,
      "autoplayTimeout": 5000,
      "loop": true,
      "navigationEnabled": true,
      "mouseDrag": false,
      "paginationActiveColor": "#42b983",
      "paginationColor": "#b2ebd1",
      "paginationSize": "20",
      "paginationPadding": "10",
      "easing": "ease",
      "speed": "1000"
    }
  }, [_c('slide', [_c('div', {
    staticClass: "carouselHeader"
  }, [_c('h2', [_c('scanSlideRef', [_vm._v("Slide #1")]), _c('br'), _vm._v("Based on Stack Overflow's Worldwide 2018 Poll of 100,000 Developers,"), _c('br'), _vm._v("Top 3 Developer-Types Share Only One Common Language: JavaScript")], 1), _vm._v(" "), _c('a', {
    staticClass: "urlLink-CarrouselHeader",
    attrs: {
      "href": "https://insights.stackoverflow.com/survey/2018#developer-roles",
      "target": "_blank"
    }
  }, [_vm._v("[https://insights.stackoverflow.com/survey/2018#developer-roles]")])]), _vm._v(" "), _c('img', {
    attrs: {
      "src": "/static/work/vision-dir/Stackoverflow-DeveloperType-Survey.png"
    }
  })]), _vm._v(" "), _c('slide', [_c('div', {
    staticClass: "carouselHeader"
  }, [_c('h2', [_c('scanSlideRef', [_vm._v("Slide #2")]), _c('br'), _vm._v("Based on Stack Overflow's Worldwide 2018 Poll of 100,000 Developers,"), _c('br'), _vm._v("JavaScript, CSS, HTML (All Web-Based Tools) are Top 3 in Popularity")], 1), _vm._v(" "), _c('a', {
    staticClass: "urlLink-CarrouselHeader",
    attrs: {
      "href": "https://insights.stackoverflow.com/survey/2018#most-popular-technologies",
      "target": "_blank"
    }
  }, [_vm._v("[https://insights.stackoverflow.com/survey/2018#most-popular-technologies]")])]), _vm._v(" "), _c('img', {
    attrs: {
      "src": "/static/work/vision-dir/Stackoverflow-MostPopularTech-JavaScript.png"
    }
  })]), _vm._v(" "), _c('slide', [_c('div', {
    staticClass: "carouselHeader"
  }, [_c('h2', [_c('scanSlideRef', [_vm._v("Slide #3")]), _c('br'), _vm._v("Based on GitHub's 3-Year Star-Ratings of Top 3 JS Frameworks,"), _c('br'), _vm._v("Vue.js #1 in Greatest Momentum (React #2)")], 1), _vm._v(" "), _c('a', {
    staticClass: "urlLink-CarrouselHeader",
    attrs: {
      "href": "http://www.timqian.com/star-history/#facebook/react&angular/angular&vuejs/vue",
      "target": "_blank"
    }
  }, [_vm._v("[http://www.timqian.com/star-history/#facebook/react&angular/angular&vuejs/vue]")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('a', {
    staticClass: "urlLink-CarrouselHeader",
    attrs: {
      "href": "https://bestof.js.org/tags/framework/trending/last-12-months",
      "target": "_blank"
    }
  }, [_vm._v("[https://bestof.js.org/tags/framework/trending/last-12-months]")])]), _vm._v(" "), _c('img', {
    attrs: {
      "src": "/static/work/vision-dir/BestOfJsDotOrg-UiFramework-GithubStars.png"
    }
  })]), _vm._v(" "), _c('slide', [_c('div', {
    staticClass: "carouselHeader"
  }, [_c('h2', [_c('scanSlideRef', [_vm._v("Slide #4")]), _c('br'), _vm._v("Based on Worldwide 2017 Poll of 28,000 JS Developers,"), _c('br'), _vm._v("Vue.js #1 in Potential Market for Training (React #2)")], 1), _vm._v(" "), _c('a', {
    staticClass: "urlLink-CarrouselHeader",
    attrs: {
      "href": "https://stateofjs.com/2017/front-end/results/",
      "target": "_blank"
    }
  }, [_vm._v("[https://stateofjs.com/2017/front-end/results/]")])]), _vm._v(" "), _c('img', {
    attrs: {
      "src": "/static/work/vision-dir/VueVsReact-StateOfJsDotCom.png"
    }
  })]), _vm._v(" "), _c('slide', [_c('div', {
    staticClass: "carouselHeader"
  }, [_c('h2', [_c('scanSlideRef', [_vm._v("Slide #5")]), _c('br'), _vm._v("Based on GitHub's 2017 Star-Ratings of All JS Projects,"), _c('br'), _vm._v("Vue.js #1 in Popularity (React #2)")], 1), _vm._v(" "), _c('a', {
    staticClass: "urlLink-CarrouselHeader",
    attrs: {
      "href": "https://risingstars.js.org/2017/en/#section-all",
      "target": "_blank"
    }
  }, [_vm._v("[https://risingstars.js.org/2017/en/#section-all]")])]), _vm._v(" "), _c('img', {
    attrs: {
      "src": "/static/work/vision-dir/VueVsReact-RisingStarsDotJsDotOrg.png"
    }
  })]), _vm._v(" "), _c('slide', [_c('div', {
    staticClass: "carouselHeader"
  }, [_c('h2', [_c('scanSlideRef', [_vm._v("Slide #6")]), _c('br'), _vm._v("Based on Stack Overflow's Worldwide 2018 Poll of 100,000 Developers,"), _c('br'), _vm._v("Node.js #1 in Framework Popularity")], 1), _vm._v(" "), _c('a', {
    staticClass: "urlLink-CarrouselHeader",
    attrs: {
      "href": "https://insights.stackoverflow.com/survey/2018#technology-frameworks-libraries-and-tools",
      "target": "_blank"
    }
  }, [_vm._v("[https://insights.stackoverflow.com/survey/2018#technology-frameworks-libraries-and-tools]")])]), _vm._v(" "), _c('img', {
    attrs: {
      "src": "/static/work/vision-dir/Stackoverflow-Framework-Node-Survey.png"
    }
  })])], 1)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h1', [_vm._v("A Vision for Silicon Valley's First "), _c('br'), _vm._v("Open-Source, Competition-Grade & Lower-Cost Robotics System...")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h1', [_vm._v("...Inspires a Progressive Vision for"), _c('br'), _vm._v("Students as 'Web/Cloud-Innovators' through Computer Science")])
}]}

/***/ }),
/* 117 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "divStyle"
  }, [_c('ul', {
    staticClass: "ulStyle"
  }, _vm._l((_vm.projects), function(project) {
    return (project.category == _vm.projectCategory) ? _c('li', [_c('a', {
      staticClass: "button",
      attrs: {
        "target": "_blank",
        "href": project.url
      }
    }, [(project.url !== '') ? _c('h3', [_vm._v("60-sec Screencast Now Playing"), _c('br'), _vm._v("- or -"), _c('br'), _vm._v("Press to Enter Live Demo Site:"), _c('br'), _vm._v(_vm._s(project.title)), _c('br'), _vm._v(_vm._s(project.title02))]) : (project.url === '') ? _c('h3', [_vm._v("60-sec Screencast Now Playing:"), _c('br'), _vm._v(_vm._s(project.title)), _c('br'), _vm._v(_vm._s(project.title02))]) : _vm._e(), _vm._v(" "), _c('h1', [_vm._v(" " + _vm._s(project.headLine00) + " ")]), _vm._v(" "), _c('h2', [_vm._v(" • Front-End: "), _c('b', [_vm._v(" " + _vm._s(project.headLine01) + " ")])]), _vm._v(" "), _c('h2', [_vm._v(" • Back-End: "), _c('b', [_vm._v(" " + _vm._s(project.headLine02) + " ")])]), _vm._v(" "), _c('div', {
      staticClass: "imageContainer lazy"
    }, [_c('img', {
      directives: [{
        name: "lazy",
        rawName: "v-lazy",
        value: (("/static/work/" + (project.category) + "/" + (project.slug) + "/" + (project.slug) + "_thumb.gif")),
        expression: "`/static/work/${project.category}/${project.slug}/${project.slug}_thumb.gif`"
      }],
      attrs: {
        "data-srcset": ("/static/work/" + (project.category) + "/" + (project.slug) + "/" + (project.slug) + "_thumb@2x.gif 2x")
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "spinner"
    })])])]) : _vm._e()
  })), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _vm._m(0)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "curriculumSyllabus"
  }, [_c('h1', [_vm._v("Sample Semester Syllabus (Book Reference Upon Request)")]), _vm._v(" "), _c('ul', {
    staticStyle: {
      "list-style": "disc",
      "margin-left": "2em"
    }
  }, [_c('li', [_vm._v("Week 01: Introducing Node.js")]), _vm._v(" "), _c('li', [_vm._v("Week 02: npm (Node Package Manager)")]), _vm._v(" "), _c('li', [_vm._v("Week 03: What Node.js Is Used For ")]), _vm._v(" "), _c('li', [_vm._v("Week 04: Callbacks")]), _vm._v(" "), _c('li', [_vm._v("Week 05: HTTP")]), _vm._v(" "), _c('li', [_vm._v("Week 06: Introducing Express")]), _vm._v(" "), _c('li', [_vm._v("Week 07: More on Express")]), _vm._v(" "), _c('li', [_vm._v("Week 08: Persisting Data")]), _vm._v(" "), _c('li', [_vm._v("Week 09: Debugging Node.js Applications")]), _vm._v(" "), _c('li', [_vm._v("Week 10: Testing Node.js Applications")]), _vm._v(" "), _c('li', [_vm._v("Week 11: Deploying Node.js Applications")]), _vm._v(" "), _c('li', [_vm._v("Week 12: Introducting Socket.IO")]), _vm._v(" "), _c('li', [_vm._v("Week 13: A Socket.IO Chat Server")]), _vm._v(" "), _c('li', [_vm._v("Week 14: A Streaming Twitter Client")]), _vm._v(" "), _c('li', [_vm._v("Week 15: JSON APIs")])])])
}]}

/***/ }),
/* 118 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "homeStyle"
  }, [_c('h1', [_vm._v("Career Objective")]), _vm._v(" "), _c('AccordionMenu', {
    attrs: {
      "items_Stage01": _vm.items_Stage00
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 119 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "divStyle"
  }, [_c('ul', {
    staticClass: "ulStyle"
  }, _vm._l((_vm.projects), function(project) {
    return (project.category == _vm.projectCategory) ? _c('li', [_c('a', {
      staticClass: "button",
      attrs: {
        "target": "_blank",
        "href": project.url
      }
    }, [(project.url !== '') ? _c('h3', [_vm._v("60-sec Screencast Now Playing"), _c('br'), _vm._v("- or -"), _c('br'), _vm._v("Press to Enter Live Demo Site:"), _c('br'), _vm._v(_vm._s(project.title)), _c('br'), _vm._v(_vm._s(project.title02))]) : (project.url === '') ? _c('h3', [_vm._v("60-sec Screencast Now Playing:"), _c('br'), _vm._v(_vm._s(project.title)), _c('br'), _vm._v(_vm._s(project.title02))]) : _vm._e(), _vm._v(" "), _c('h1', [_vm._v(" " + _vm._s(project.headLine00) + " ")]), _vm._v(" "), _c('h2', [_vm._v(" • Front-End: "), _c('b', [_vm._v(" " + _vm._s(project.headLine01) + " ")])]), _vm._v(" "), _c('h2', [_vm._v(" • Back-End: "), _c('b', [_vm._v(" " + _vm._s(project.headLine02) + " ")])]), _vm._v(" "), _c('div', {
      staticClass: "imageContainer lazy"
    }, [_c('img', {
      directives: [{
        name: "lazy",
        rawName: "v-lazy",
        value: (("/static/work/" + (project.category) + "/" + (project.slug) + "/" + (project.slug) + "_thumb.gif")),
        expression: "`/static/work/${project.category}/${project.slug}/${project.slug}_thumb.gif`"
      }],
      attrs: {
        "data-srcset": ("/static/work/" + (project.category) + "/" + (project.slug) + "/" + (project.slug) + "_thumb@2x.gif 2x")
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "spinner"
    })])])]) : _vm._e()
  })), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _vm._m(0)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "curriculumSyllabus"
  }, [_c('h1', [_vm._v("Sample Semester Syllabus (Book Reference Upon Request)")]), _vm._v(" "), _c('ul', {
    staticStyle: {
      "list-style": "disc",
      "margin-left": "2em"
    }
  }, [_c('li', [_vm._v("Week 01: Introducing Vue.js")]), _vm._v(" "), _c('li', [_vm._v("Week 02: The Vue instance")]), _vm._v(" "), _c('li', [_vm._v("Week 03: Adding interactivity")]), _vm._v(" "), _c('li', [_vm._v("Week 04: Forms and inputs")]), _vm._v(" "), _c('li', [_vm._v("Week 05: Conditionals, looping, and lists")]), _vm._v(" "), _c('li', [_vm._v("Week 06: Working with components")]), _vm._v(" "), _c('li', [_vm._v("Week 07: Conditionals, looping, and lists")]), _vm._v(" "), _c('li', [_vm._v("Week 08: Advanced components and routing")]), _vm._v(" "), _c('li', [_vm._v("Week 09: Transitions and animations")]), _vm._v(" "), _c('li', [_vm._v("Week 10: Extending Vue")]), _vm._v(" "), _c('li', [_vm._v("Week 11: Vuex: State Management Part 1")]), _vm._v(" "), _c('li', [_vm._v("Week 12: Vuex: State Management Part 2")]), _vm._v(" "), _c('li', [_vm._v("Week 13: Communicating with a server: Part 1")]), _vm._v(" "), _c('li', [_vm._v("Week 14: Communicating with a server: Part 2")]), _vm._v(" "), _c('li', [_vm._v("Week 15: Testing")])])])
}]}

/***/ }),
/* 120 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    style: ({
      fontSize: _vm.fontSize + 'px'
    }),
    attrs: {
      "id": "app"
    }
  }, [_c('header', {
    staticClass: "header"
  }, [_vm._m(0), _vm._v(" "), _c('h2', [_vm._v("Portfolio of JavaScript & Python Industy-Inspired, Curriculum-Based Projects")]), _vm._v(" "), _c('mainNavComponent')], 1), _vm._v(" "), _c('section', {
    staticClass: "route"
  }, [_c('router-view')], 1), _vm._v(" "), _c('footer', {
    staticClass: "footer"
  }, [_vm._m(1), _vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "fontSizeChange_Section"
  }, [_c('button', {
    staticClass: "button fontSizeChange_Button",
    on: {
      "click": function($event) {
        _vm.fontSize--
      }
    }
  }, [_vm._v("\n      Font Size: -\n    ")]), _vm._v(" "), _c('button', {
    staticClass: "button fontSizeChange_Button",
    on: {
      "click": function($event) {
        _vm.fontSize++
      }
    }
  }, [_vm._v("\n      Font Size: +\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "fontSizeChange_TextStatus",
    style: ([_vm.fontSizeChange_00_Style, _vm.fontSizeChange_01_Style, {
      fontSize: _vm.fontSize + 'px'
    }])
  }, [_vm._v("\n      Font Size: " + _vm._s(_vm.fontSize) + "\n    ")])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "headerUpper"
  }, [_c('h1', [_vm._v("Jason W Chan")]), _vm._v(" "), _c('h2', [_vm._v("Web Full-Stack & Robotics Instructor / Developer")]), _vm._v(" "), _c('h2', [_vm._v("Primary, Secondary & Collegiate Ed")]), _vm._v(" "), _c('h4', [_vm._v("jasonc@eande.world, mobile/text 408-828-5131, "), _c('a', {
    staticClass: "urlLink",
    attrs: {
      "href": "https://www.linkedin.com/in/jasonwchan1025/",
      "target": "_blank"
    }
  }, [_vm._v("www.linkedin.com/in/jasonwchan1025/")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "rel": "license",
      "href": "http://creativecommons.org/licenses/by-nc-sa/4.0/"
    }
  }, [_c('img', {
    staticStyle: {
      "border-width": "0"
    },
    attrs: {
      "alt": "Creative Commons License",
      "src": "https://i.creativecommons.org/l/by-nc-sa/4.0/88x31.png"
    }
  }), _vm._v("   ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "rel": "license",
      "href": "http://creativecommons.org/licenses/by-nc-sa/4.0/"
    }
  }, [_vm._v("Portfolio developed by Jason W Chan using Vue.js, Node.js & Netlify "), _c('br'), _vm._v(" Creative Commons Attribution-NonCommercial-ShareAlike "), _c('br'), _vm._v(" 4.0 International License")])
}]}

/***/ }),
/* 121 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "divStyle"
  }, [_c('ul', {
    staticClass: "ulStyle"
  }, _vm._l((_vm.projects), function(project) {
    return (project.category == _vm.projectCategory) ? _c('li', [_c('a', {
      staticClass: "button",
      attrs: {
        "target": "_blank",
        "href": project.url
      }
    }, [(project.url !== '') ? _c('h3', [_vm._v("60-sec Screencast Now Playing"), _c('br'), _vm._v("- or -"), _c('br'), _vm._v("Press to Enter Live Demo Site:"), _c('br'), _vm._v(_vm._s(project.title)), _c('br'), _vm._v(_vm._s(project.title02))]) : (project.url === '') ? _c('h3', [_vm._v("60-sec Screencast Now Playing:"), _c('br'), _vm._v(_vm._s(project.title)), _c('br'), _vm._v(_vm._s(project.title02))]) : _vm._e(), _vm._v(" "), _c('h1', [_vm._v(" " + _vm._s(project.headLine00) + " ")]), _vm._v(" "), (project.headLine01 !== '') ? _c('h2', [_vm._v(" • Front-End: "), _c('b', [_vm._v(" " + _vm._s(project.headLine01) + " ")])]) : _vm._e(), _vm._v(" "), (project.headLine02 !== '') ? _c('h2', [_vm._v(" • Back-End: "), _c('b', [_vm._v(" " + _vm._s(project.headLine02) + " ")])]) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "imageContainer lazy"
    }, [_c('img', {
      directives: [{
        name: "lazy",
        rawName: "v-lazy",
        value: (("/static/work/" + (project.category) + "/" + (project.slug) + "/" + (project.slug) + "_thumb.gif")),
        expression: "`/static/work/${project.category}/${project.slug}/${project.slug}_thumb.gif`"
      }],
      attrs: {
        "data-srcset": ("/static/work/" + (project.category) + "/" + (project.slug) + "/" + (project.slug) + "_thumb@2x.gif 2x")
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "spinner"
    })])])]) : _vm._e()
  })), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _vm._m(0)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "curriculumSyllabus"
  }, [_c('h1', [_vm._v("Sample Semester Syllabus (Book Reference Upon Request)")]), _vm._v(" "), _c('ul', {
    staticStyle: {
      "list-style": "disc",
      "margin-left": "2em"
    }
  }, [_c('li', [_vm._v("Week 01: Intro & Setup")]), _vm._v(" "), _c('li', [_vm._v("Week 02: Blink LED ~ Internal w/ Arduino IDE C/C++ Programming")]), _vm._v(" "), _c('li', [_vm._v("Week 03: Servo_180-Degrees_Arm & Serial-Monitor")]), _vm._v(" "), _c('li', [_vm._v("Week 04: Servo_Continuous-Degrees_Wheel, Serial-Monitor & User-Entry")]), _vm._v(" "), _c('li', [_vm._v("Week 05: Infrared (Ir) Remote-Control on Servo_180-Degrees_Arm")]), _vm._v(" "), _c('li', [_vm._v("Week 06: Hardware Chassis ~ Create Top & Bottom")]), _vm._v(" "), _c('li', [_vm._v("Week 07: LCD Diagnostic: Servo_180-Degrees_Arm")]), _vm._v(" "), _c('li', [_vm._v("Week 08: LCD Diagnostic: Servo_Continuous-Degrees_Wheel")]), _vm._v(" "), _c('li', [_vm._v("Week 09: Hardware: Power-Grid")]), _vm._v(" "), _c('li', [_vm._v("Week 10: Hardware: Rear-Servos & Infrared Receiver")]), _vm._v(" "), _c('li', [_vm._v("Week 11: Rear-Servos: Rear-Servos, Wheels, T.A.C.H.NOLOGY® B.a.R.™ & Surface-Slider")]), _vm._v(" "), _c('li', [_vm._v("Week 12: Rear-Servos: Go-Forward Straight-Line Fine-Tuning")]), _vm._v(" "), _c('li', [_vm._v("Week 13: Mid-Right-Arm & Payload-Carrier-Box")]), _vm._v(" "), _c('li', [_vm._v("Week 14: Helmet & Accessories")]), _vm._v(" "), _c('li', [_vm._v("Week 15: Integration Test")])])])
}]}

/***/ }),
/* 122 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "mainNav"
  }, [(_vm.store.getters.tabModeGet == 0) ? _c('router-link', {
    attrs: {
      "tag": "a",
      "to": "/home"
    },
    nativeOn: {
      "click": function($event) {
        _vm.store.commit('tabModeSet', '0')
      }
    }
  }, [_c('b', [_vm._v("Home")])]) : _c('router-link', {
    attrs: {
      "tag": "a",
      "to": "/home"
    },
    nativeOn: {
      "click": function($event) {
        _vm.store.commit('tabModeSet', '0')
      }
    }
  }, [_vm._v("Home")]), _vm._v(" "), (_vm.store.getters.tabModeGet == 6) ? _c('router-link', {
    attrs: {
      "tag": "a",
      "to": "/resume"
    },
    nativeOn: {
      "click": function($event) {
        _vm.store.commit('tabModeSet', '6')
      }
    }
  }, [_c('b', [_vm._v("Personal Resumé")])]) : _c('router-link', {
    attrs: {
      "tag": "a",
      "to": "/resume"
    },
    nativeOn: {
      "click": function($event) {
        _vm.store.commit('tabModeSet', '6')
      }
    }
  }, [_vm._v("Personal Resumé")]), _vm._v(" "), (_vm.store.getters.tabModeGet == 7) ? _c('router-link', {
    attrs: {
      "tag": "a",
      "to": "/vision"
    },
    nativeOn: {
      "click": function($event) {
        _vm.store.commit('tabModeSet', '7')
      }
    }
  }, [_c('b', [_vm._v("Vision:"), _c('br'), _vm._v("Web & Robotics")])]) : _c('router-link', {
    attrs: {
      "tag": "a",
      "to": "/vision"
    },
    nativeOn: {
      "click": function($event) {
        _vm.store.commit('tabModeSet', '7')
      }
    }
  }, [_vm._v("Vision:"), _c('br'), _vm._v("Web & Robotics")]), _vm._v(" "), (_vm.store.getters.tabModeGet == 1) ? _c('router-link', {
    attrs: {
      "tag": "a",
      "to": "/projects-react"
    },
    nativeOn: {
      "click": function($event) {
        _vm.store.commit('tabModeSet', '1')
      }
    }
  }, [_c('b', [_vm._v("Web FrontEnd:"), _c('br'), _vm._v("JavaScript React")])]) : _c('router-link', {
    attrs: {
      "tag": "a",
      "to": "/projects-react"
    },
    nativeOn: {
      "click": function($event) {
        _vm.store.commit('tabModeSet', '1')
      }
    }
  }, [_vm._v("Web FrontEnd:"), _c('br'), _vm._v("JavaScript React")]), _vm._v(" "), (_vm.store.getters.tabModeGet == 2) ? _c('router-link', {
    attrs: {
      "tag": "a",
      "to": "/projects-vue-js"
    },
    nativeOn: {
      "click": function($event) {
        _vm.store.commit('tabModeSet', '2')
      }
    }
  }, [_c('b', [_vm._v("Web FrontEnd:"), _c('br'), _vm._v("JavaScript Vue.js")])]) : _c('router-link', {
    attrs: {
      "tag": "a",
      "to": "/projects-vue-js"
    },
    nativeOn: {
      "click": function($event) {
        _vm.store.commit('tabModeSet', '2')
      }
    }
  }, [_vm._v("Web FrontEnd:"), _c('br'), _vm._v("JavaScript Vue.js")]), _vm._v(" "), (_vm.store.getters.tabModeGet == 3) ? _c('router-link', {
    attrs: {
      "tag": "a",
      "to": "/projects-node-js"
    },
    nativeOn: {
      "click": function($event) {
        _vm.store.commit('tabModeSet', '3')
      }
    }
  }, [_c('b', [_vm._v("Web BackEnd:"), _c('br'), _vm._v("JavaScript Node.js")])]) : _c('router-link', {
    attrs: {
      "tag": "a",
      "to": "/projects-node-js"
    },
    nativeOn: {
      "click": function($event) {
        _vm.store.commit('tabModeSet', '3')
      }
    }
  }, [_vm._v("Web BackEnd:"), _c('br'), _vm._v("JavaScript Node.js")]), _vm._v(" "), (_vm.store.getters.tabModeGet == 4) ? _c('router-link', {
    attrs: {
      "tag": "a",
      "to": "/projects-robotics"
    },
    nativeOn: {
      "click": function($event) {
        _vm.store.commit('tabModeSet', '4')
      }
    }
  }, [_c('b', [_vm._v("JavaScript/"), _c('br'), _vm._v("Python:"), _c('br'), _vm._v("Robotics")])]) : _c('router-link', {
    attrs: {
      "tag": "a",
      "to": "/projects-robotics"
    },
    nativeOn: {
      "click": function($event) {
        _vm.store.commit('tabModeSet', '4')
      }
    }
  }, [_vm._v("JavaScript/"), _c('br'), _vm._v("Python:"), _c('br'), _vm._v("Robotics")]), _vm._v(" "), (_vm.store.getters.tabModeGet == 5) ? _c('router-link', {
    attrs: {
      "tag": "a",
      "to": "/projects-industry-siemens"
    },
    nativeOn: {
      "click": function($event) {
        _vm.store.commit('tabModeSet', '5')
      }
    }
  }, [_c('b', [_vm._v("JavaScript/"), _c('br'), _vm._v("Python:"), _c('br'), _vm._v("Industry")])]) : _c('router-link', {
    attrs: {
      "tag": "a",
      "to": "/projects-industry-siemens"
    },
    nativeOn: {
      "click": function($event) {
        _vm.store.commit('tabModeSet', '5')
      }
    }
  }, [_vm._v("JavaScript/"), _c('br'), _vm._v("Python:"), _c('br'), _vm._v("Industry")])], 1)
},staticRenderFns: []}

/***/ }),
/* 123 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.project) ? _c('div', {
    staticClass: "project"
  }, [_c('div', {
    staticClass: "details"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col"
  }, [_c('div', [_c('h2', {
    domProps: {
      "innerHTML": _vm._s(_vm.project.title)
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col buttons"
  }, [(_vm.project.github) ? _c('a', {
    staticClass: "button",
    attrs: {
      "target": "_blank",
      "href": _vm.project.github
    }
  }, [_vm._v("GitHub Repo")]) : _vm._e(), _vm._v(" "), _c('a', {
    staticClass: "button",
    attrs: {
      "target": "_blank",
      "href": _vm.project.url
    }
  }, [_vm._v("Live Site")])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col ie11Hack"
  }, [_c('p', {
    domProps: {
      "innerHTML": _vm._s(_vm.project.description)
    }
  })])])]), _vm._v(" "), _c('nav', [_c('div', {
    staticClass: "container"
  }, [(_vm.previousProject.slug) ? _c('router-link', {
    staticClass: "button",
    attrs: {
      "tag": "a",
      "to": ("/work/" + (_vm.previousProject.category) + "/" + (_vm.previousProject.slug))
    }
  }, [_vm._v("Previous Project")]) : _vm._e(), _vm._v(" "), _c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.project.title)
    }
  }), _vm._v(" "), (_vm.nextProject.slug) ? _c('router-link', {
    staticClass: "button",
    attrs: {
      "tag": "a",
      "to": ("/work/" + (_vm.nextProject.category) + "/" + (_vm.nextProject.slug))
    }
  }, [_vm._v("Next Project")]) : _vm._e()], 1)]), _vm._v(" "), _c('ul', {
    staticClass: "image"
  }, _vm._l((_vm.project.imageListLength), function(n) {
    return _c('li', {
      staticClass: "lazy"
    }, [_c('img', {
      directives: [{
        name: "lazy",
        rawName: "v-lazy",
        value: (("/static/work/" + (_vm.project.category) + "/" + (_vm.project.slug) + "/" + (_vm.project.slug) + "-" + n + ".png")),
        expression: "`/static/work/${project.category}/${project.slug}/${project.slug}-${n}.png`"
      }],
      attrs: {
        "data-srcset": ("/static/work/" + (_vm.project.category) + "/" + (_vm.project.slug) + "/" + (_vm.project.slug) + "-" + n + "@2x.png 2x")
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "spinner"
    })])
  }))]) : _c('Error')
},staticRenderFns: []}

/***/ }),
/* 124 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "resumeStyle"
  }, [_c('ul', _vm._l((_vm.jobs), function(job_) {
    return _c('li', {
      key: job_.id
    }, [(job_.job_group_name != null) ? _c('div', {
      staticClass: "jobGroup"
    }, [_c('p', {
      staticClass: "jobGroupName"
    }, [_vm._v(_vm._s(job_.job_group_name))]), _vm._v(" "), _c('p', {
      staticClass: "jobGroupText",
      domProps: {
        "innerHTML": _vm._s(job_.job_group_text)
      }
    })]) : _vm._e(), _vm._v(" "), (job_.job_title != null) ? _c('div', {
      staticClass: "job"
    }, [_c('ul', [_c('li', {
      staticClass: "jobHead"
    }, [_c('span', {
      staticClass: "jobTitle",
      domProps: {
        "innerHTML": _vm._s(job_.job_title)
      }
    }), _vm._v(" "), _c('span', {
      staticClass: "jobTimePeriod"
    }, [_vm._v(_vm._s(job_.job_timePeriod.from) + " – " + _vm._s(job_.job_timePeriod.to))])]), _vm._v(" "), _c('li', {
      staticClass: "jobBody"
    }, [_c('span', [_c('span', {
      staticClass: "jobCompany",
      domProps: {
        "innerHTML": _vm._s(job_.job_company)
      }
    }, [_vm._v(",")]), _vm._v(" "), _c('span', {
      staticClass: "jobLocation"
    }, [_vm._v(_vm._s(job_.job_location))]), _vm._v(" "), (job_.job_url != null) ? _c('span', [_c('a', {
      staticClass: "jobUrl",
      attrs: {
        "href": job_.job_url
      }
    }, [_c('u', [_vm._v(_vm._s(job_.job_url))])])]) : _vm._e()]), _vm._v(" "), _c('span', [(job_.job_ageRange != null) ? _c('span', {
      staticClass: "jobAgeRange"
    }, [_vm._v(_vm._s(job_.job_ageRange))]) : _vm._e()])])])]) : _vm._e(), _vm._v(" "), _vm._l((job_.job_childs), function(job_child) {
      return _c('div', {
        key: job_child.id
      }, [_c('p', [_c('span', {
        staticClass: "jobChild",
        domProps: {
          "innerHTML": _vm._s(job_child.text)
        }
      })])])
    }), _vm._v(" "), _vm._l((job_.skills_groups), function(skills_group) {
      return _c('div', {
        key: skills_group.id,
        staticClass: "skillsGroup"
      }, [(skills_group.skills_group_group_name != null || skills_group.skills_group_group_text != null) ? _c('div', {
        staticClass: "skillsGroupGroup"
      }, [(skills_group.skills_group_group_name != null) ? _c('p', {
        staticClass: "skillsGroupGroupName",
        domProps: {
          "innerHTML": _vm._s(skills_group.skills_group_group_name)
        }
      }) : _vm._e(), _vm._v(" "), (skills_group.skills_group_group_text != null) ? _c('p', {
        staticClass: "skillsGroupGroupText",
        domProps: {
          "innerHTML": _vm._s(skills_group.skills_group_group_text)
        }
      }) : _vm._e()]) : _vm._e(), _vm._v(" "), (skills_group.skills_group_name != null) ? _c('div', {
        staticClass: "skillsGroupName"
      }, [(skills_group.skills_group_name != null) ? _c('span', {
        staticClass: "skillsGroupHead",
        domProps: {
          "innerHTML": _vm._s(skills_group.skills_group_name)
        }
      }) : _vm._e(), _vm._v(" "), _c('span', [(skills_group.skills_group_timePeriod.from != null) ? _c('span', {
        staticClass: "skillsGroupTimePeriod"
      }, [_vm._v(_vm._s(skills_group.skills_group_timePeriod.from))]) : _vm._e(), _vm._v(" "), (skills_group.skills_group_timePeriod.to != null) ? _c('span', {
        staticClass: "skillsGroupTimePeriod"
      }, [_vm._v(" – " + _vm._s(skills_group.skills_group_timePeriod.to))]) : _vm._e()])]) : _vm._e(), _vm._v(" "), _c('div', {
        staticClass: "skillsGroupText"
      }, [(skills_group.skills_group_text != null) ? _c('span', {
        staticClass: "skillsGroupBody",
        domProps: {
          "innerHTML": _vm._s(skills_group.skills_group_text)
        }
      }) : _vm._e(), _vm._v(" "), (skills_group.skills_group_ageRange != null) ? _c('span', {
        staticClass: "skillsGroupAgeRange"
      }, [_vm._v(_vm._s(skills_group.skills_group_ageRange))]) : _vm._e()]), _vm._v(" "), _vm._l((skills_group.skills), function(skill_) {
        return _c('div', {
          key: skill_.id,
          staticClass: "skill"
        }, [(skill_.skill_head != null && skill_.skill_link != null) ? _c('div', [_c('div', {
          staticClass: "buttonGroup"
        }, [(skill_.skill_link_tab_index === '0') ? _c('router-link', {
          staticClass: "button skillHead",
          attrs: {
            "tag": "a",
            "to": ("" + (skill_.skill_link))
          },
          domProps: {
            "innerHTML": _vm._s(skill_.skill_head)
          },
          nativeOn: {
            "click": function($event) {
              _vm.store.commit('tabModeSet', '00')
            }
          }
        }) : _vm._e(), _vm._v(" "), (skill_.skill_link_tab_index === '1') ? _c('router-link', {
          staticClass: "button skillHead",
          attrs: {
            "tag": "a",
            "to": ("" + (skill_.skill_link))
          },
          domProps: {
            "innerHTML": _vm._s(skill_.skill_head)
          },
          nativeOn: {
            "click": function($event) {
              _vm.store.commit('tabModeSet', '01')
            }
          }
        }) : _vm._e(), _vm._v(" "), (skill_.skill_link_tab_index === '2') ? _c('router-link', {
          staticClass: "button skillHead",
          attrs: {
            "tag": "a",
            "to": ("" + (skill_.skill_link))
          },
          domProps: {
            "innerHTML": _vm._s(skill_.skill_head)
          },
          nativeOn: {
            "click": function($event) {
              _vm.store.commit('tabModeSet', '02')
            }
          }
        }) : _vm._e(), _vm._v(" "), (skill_.skill_link_tab_index === '3') ? _c('router-link', {
          staticClass: "button skillHead",
          attrs: {
            "tag": "a",
            "to": ("" + (skill_.skill_link))
          },
          domProps: {
            "innerHTML": _vm._s(skill_.skill_head)
          },
          nativeOn: {
            "click": function($event) {
              _vm.store.commit('tabModeSet', '03')
            }
          }
        }) : _vm._e(), _vm._v(" "), (skill_.skill_link_tab_index === '4') ? _c('router-link', {
          staticClass: "button skillHead",
          attrs: {
            "tag": "a",
            "to": ("" + (skill_.skill_link))
          },
          domProps: {
            "innerHTML": _vm._s(skill_.skill_head)
          },
          nativeOn: {
            "click": function($event) {
              _vm.store.commit('tabModeSet', '04')
            }
          }
        }) : _vm._e(), _vm._v(" "), (skill_.skill_link_tab_index === '5') ? _c('a', {
          staticClass: "button skillHead",
          attrs: {
            "href": "http://www.eande.world",
            "target": "_blank"
          },
          domProps: {
            "innerHTML": _vm._s(skill_.skill_head)
          }
        }, [_vm._v(":")]) : _vm._e(), _vm._v(" "), _c('span', {
          staticClass: "skillBody"
        }, [_vm._v(_vm._s(skill_.skill_body))])], 1), _vm._v(" "), _vm._l((skill_.skill_childs), function(skill_child) {
          return _c('div', {
            key: skill_child.id,
            staticClass: "skillChild"
          }, [_c('p', [_c('span', {
            domProps: {
              "innerHTML": _vm._s(skill_child.text)
            }
          })])])
        })], 2) : (skill_.skill_head != null && skill_.skill_link == null) ? _c('div', [_c('div', [_c('b', {
          staticClass: "skillHead",
          domProps: {
            "innerHTML": _vm._s(skill_.skill_head)
          }
        }), _vm._v(" "), _c('span', {
          staticClass: "skillBody"
        }, [_vm._v(_vm._s(skill_.skill_body))])]), _vm._v(" "), _vm._l((skill_.skill_childs), function(skill_child) {
          return _c('div', {
            key: skill_child.id,
            staticClass: "skillChild"
          }, [_c('p', [_c('span', {
            domProps: {
              "innerHTML": _vm._s(skill_child.text)
            }
          })])])
        })], 2) : _vm._e()])
      })], 2)
    })], 2)
  }))])
},staticRenderFns: []}

/***/ }),
/* 125 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "divStyle"
  }, [_c('ul', {
    staticClass: "ulStyle"
  }, _vm._l((_vm.projects), function(project) {
    return (project.category == _vm.projectCategory) ? _c('li', [_c('a', {
      staticClass: "button",
      attrs: {
        "target": "_blank",
        "href": project.url
      }
    }, [(project.url !== '') ? _c('h3', [_vm._v("60-sec Screencast Now Playing"), _c('br'), _vm._v("- or -"), _c('br'), _vm._v("Press to Enter Live Demo Site:"), _c('br'), _vm._v(_vm._s(project.title)), _c('br'), _vm._v(_vm._s(project.title02))]) : (project.url === '') ? _c('h3', [_vm._v("60-sec Screencast Now Playing:"), _c('br'), _vm._v(_vm._s(project.title)), _c('br'), _vm._v(_vm._s(project.title02))]) : _vm._e(), _vm._v(" "), _c('h1', [_vm._v(" " + _vm._s(project.headLine00) + " ")]), _vm._v(" "), _c('h2', [_vm._v(" • Front-End: "), _c('b', [_vm._v(" " + _vm._s(project.headLine01) + " ")])]), _vm._v(" "), _c('h2', [_vm._v(" • Back-End: "), _c('b', [_vm._v(" " + _vm._s(project.headLine02) + " ")])]), _vm._v(" "), _c('div', {
      staticClass: "imageContainer lazy"
    }, [_c('img', {
      directives: [{
        name: "lazy",
        rawName: "v-lazy",
        value: (("/static/work/" + (project.category) + "/" + (project.slug) + "/" + (project.slug) + "_thumb.gif")),
        expression: "`/static/work/${project.category}/${project.slug}/${project.slug}_thumb.gif`"
      }],
      attrs: {
        "data-srcset": ("/static/work/" + (project.category) + "/" + (project.slug) + "/" + (project.slug) + "_thumb@2x.gif 2x")
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "spinner"
    })])])]) : _vm._e()
  })), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _vm._m(0)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "curriculumSyllabus"
  }, [_c('h1', [_vm._v("Sample Semester Syllabus (Book Reference Upon Request)")]), _vm._v(" "), _c('ul', {
    staticStyle: {
      "list-style": "disc",
      "margin-left": "2em"
    }
  }, [_c('li', [_vm._v("Week 01: Introducing React")]), _vm._v(" "), _c('li', [_vm._v("Week 02: Building Your First React App")]), _vm._v(" "), _c('li', [_vm._v("Week 03: Components in React")]), _vm._v(" "), _c('li', [_vm._v("Week 04: Styling in React")]), _vm._v(" "), _c('li', [_vm._v("Week 05: Creating Complex Components")]), _vm._v(" "), _c('li', [_vm._v("Week 06: Transferring Properties (Props)")]), _vm._v(" "), _c('li', [_vm._v("Week 07: Meet JSX: Part 2")]), _vm._v(" "), _c('li', [_vm._v("Week 08: Dealing with State")]), _vm._v(" "), _c('li', [_vm._v("Week 09: Going from Data to UI")]), _vm._v(" "), _c('li', [_vm._v("Week 10: Working with Events")]), _vm._v(" "), _c('li', [_vm._v("Week 11: The Component Lifecycle")]), _vm._v(" "), _c('li', [_vm._v("Week 12: Accessing DOM Elements")]), _vm._v(" "), _c('li', [_vm._v("Week 13: Creating a Single-Page App Using React Router")]), _vm._v(" "), _c('li', [_vm._v("Week 14: Building a Todo List App")]), _vm._v(" "), _c('li', [_vm._v("Week 15: Setting Up Your React Development Environment")])])])
}]}

/***/ }),
/* 126 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "divStyle"
  }, [_c('ul', {
    staticClass: "ulStyle"
  }, _vm._l((_vm.projects), function(project) {
    return (project.category == _vm.projectCategory) ? _c('li', [_c('a', {
      staticClass: "button",
      attrs: {
        "target": "_blank",
        "href": project.url
      }
    }, [(project.url !== '') ? _c('h3', [_vm._v("60-sec Screencast Now Playing"), _c('br'), _vm._v("- or -"), _c('br'), _vm._v("Press to Enter Live Demo Site:"), _c('br'), _vm._v(_vm._s(project.title)), _c('br'), _vm._v(_vm._s(project.title02))]) : (project.url === '') ? _c('h3', [_vm._v("60-sec Screencast Now Playing:"), _c('br'), _vm._v(_vm._s(project.title)), _c('br'), _vm._v(_vm._s(project.title02))]) : _vm._e(), _vm._v(" "), _c('h1', [_vm._v(" " + _vm._s(project.headLine00) + " ")]), _vm._v(" "), _c('h2', [_vm._v(" • Front-End: "), _c('b', [_vm._v(" " + _vm._s(project.headLine01) + " ")])]), _vm._v(" "), _c('h2', [_vm._v(" • Back-End: "), _c('b', [_vm._v(" " + _vm._s(project.headLine02) + " ")])]), _vm._v(" "), _c('div', {
      staticClass: "imageContainer lazy"
    }, [_c('img', {
      directives: [{
        name: "lazy",
        rawName: "v-lazy",
        value: (("/static/work/" + (project.category) + "/" + (project.slug) + "/" + (project.slug) + "_thumb.gif")),
        expression: "`/static/work/${project.category}/${project.slug}/${project.slug}_thumb.gif`"
      }],
      attrs: {
        "data-srcset": ("/static/work/" + (project.category) + "/" + (project.slug) + "/" + (project.slug) + "_thumb@2x.gif 2x")
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "spinner"
    })])])]) : _vm._e()
  }))])
},staticRenderFns: []}

/***/ }),
/* 127 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "error"
  }, [_vm._v("\n  404: Not Found\n")])
},staticRenderFns: []}

/***/ }),
/* 128 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "resumeShortStyle"
  }, [_c('ul', _vm._l((_vm.jobs), function(job_) {
    return _c('li', {
      key: job_.id
    }, [(job_.job_group_name != null) ? _c('div', {
      staticClass: "jobGroup"
    }, [_c('p', {
      staticClass: "jobGroupName"
    }, [_vm._v(_vm._s(job_.job_group_name))]), _vm._v(" "), _c('p', {
      staticClass: "jobGroupText"
    }, [_vm._v(_vm._s(job_.job_group_text))])]) : _vm._e(), _vm._v(" "), (job_.job_title != null) ? _c('div', {
      staticClass: "job"
    }, [_c('ul', [_c('li', {
      staticClass: "jobHead"
    }, [_c('span', {
      staticClass: "jobTitle",
      domProps: {
        "innerHTML": _vm._s(job_.job_title)
      }
    }, [_vm._v(_vm._s(job_.job_title))]), _vm._v(" "), _c('span', {
      staticClass: "jobTimePeriod"
    }, [_vm._v(_vm._s(job_.job_timePeriod.from) + " – " + _vm._s(job_.job_timePeriod.to))])]), _vm._v(" "), _c('li', {
      staticClass: "jobBody"
    }, [_c('span', [_c('span', {
      staticClass: "jobCompany",
      domProps: {
        "innerHTML": _vm._s(job_.job_company)
      }
    }, [_vm._v(",")]), _vm._v(" "), _c('span', {
      staticClass: "jobLocation"
    }, [_vm._v(_vm._s(job_.job_location))]), _vm._v(" "), (job_.job_url != null) ? _c('span', [_c('a', {
      staticClass: "jobUrl",
      attrs: {
        "href": job_.job_url
      }
    }, [_c('u', [_vm._v(_vm._s(job_.job_url))])])]) : _vm._e()]), _vm._v(" "), _c('span', [(job_.job_ageRange != null) ? _c('span', {
      staticClass: "jobAgeRange"
    }, [_vm._v(_vm._s(job_.job_ageRange))]) : _vm._e()])])])]) : _vm._e(), _vm._v(" "), _vm._l((job_.job_childs), function(job_child) {
      return _c('div', {
        key: job_child.id
      }, [_c('p', [_c('span', {
        staticClass: "jobChild",
        domProps: {
          "innerHTML": _vm._s(job_child.text)
        }
      })])])
    }), _vm._v(" "), _vm._l((job_.skills_groups), function(skills_group) {
      return _c('div', {
        key: skills_group.id,
        staticClass: "skillsGroup"
      }, [(skills_group.skills_group_group_name != null || skills_group.skills_group_group_text != null) ? _c('div', {
        staticClass: "skillsGroupGroup"
      }, [(skills_group.skills_group_group_name != null) ? _c('p', {
        staticClass: "skillsGroupGroupName",
        domProps: {
          "innerHTML": _vm._s(skills_group.skills_group_group_name)
        }
      }) : _vm._e(), _vm._v(" "), (skills_group.skills_group_group_text != null) ? _c('p', {
        staticClass: "skillsGroupGroupText",
        domProps: {
          "innerHTML": _vm._s(skills_group.skills_group_group_text)
        }
      }) : _vm._e()]) : _vm._e(), _vm._v(" "), (skills_group.skills_group_name != null) ? _c('div', {
        staticClass: "skillsGroupName"
      }, [(skills_group.skills_group_name != null) ? _c('span', {
        staticClass: "skillsGroupHead",
        domProps: {
          "innerHTML": _vm._s(skills_group.skills_group_name)
        }
      }) : _vm._e(), _vm._v(" "), _c('span', [(skills_group.skills_group_timePeriod.from != null) ? _c('span', {
        staticClass: "skillsGroupTimePeriod"
      }, [_vm._v(_vm._s(skills_group.skills_group_timePeriod.from))]) : _vm._e(), _vm._v(" "), (skills_group.skills_group_timePeriod.to != null) ? _c('span', {
        staticClass: "skillsGroupTimePeriod"
      }, [_vm._v(" – " + _vm._s(skills_group.skills_group_timePeriod.to))]) : _vm._e()])]) : _vm._e(), _vm._v(" "), _c('div', {
        staticClass: "skillsGroupText"
      }, [(skills_group.skills_group_text != null) ? _c('span', {
        staticClass: "skillsGroupBody",
        domProps: {
          "innerHTML": _vm._s(skills_group.skills_group_text)
        }
      }) : _vm._e(), _vm._v(" "), (skills_group.skills_group_ageRange != null) ? _c('span', {
        staticClass: "skillsGroupAgeRange"
      }, [_vm._v(_vm._s(skills_group.skills_group_ageRange))]) : _vm._e()]), _vm._v(" "), _vm._l((skills_group.skills), function(skill_) {
        return _c('div', {
          key: skill_.id,
          staticClass: "skill"
        }, [(skill_.skill_head != null && skill_.skill_link != null) ? _c('div', [_c('div', {
          staticClass: "buttonGroup"
        }, [(skill_.skill_link_tab_index === '0') ? _c('router-link', {
          staticClass: "button skillHead",
          attrs: {
            "tag": "a",
            "to": ("" + (skill_.skill_link))
          },
          domProps: {
            "innerHTML": _vm._s(skill_.skill_head)
          },
          nativeOn: {
            "click": function($event) {
              _vm.store.commit('tabModeSet', '00')
            }
          }
        }) : _vm._e(), _vm._v(" "), (skill_.skill_link_tab_index === '1') ? _c('router-link', {
          staticClass: "button skillHead",
          attrs: {
            "tag": "a",
            "to": ("" + (skill_.skill_link))
          },
          domProps: {
            "innerHTML": _vm._s(skill_.skill_head)
          },
          nativeOn: {
            "click": function($event) {
              _vm.store.commit('tabModeSet', '01')
            }
          }
        }) : _vm._e(), _vm._v(" "), (skill_.skill_link_tab_index === '2') ? _c('router-link', {
          staticClass: "button skillHead",
          attrs: {
            "tag": "a",
            "to": ("" + (skill_.skill_link))
          },
          domProps: {
            "innerHTML": _vm._s(skill_.skill_head)
          },
          nativeOn: {
            "click": function($event) {
              _vm.store.commit('tabModeSet', '02')
            }
          }
        }) : _vm._e(), _vm._v(" "), (skill_.skill_link_tab_index === '3') ? _c('router-link', {
          staticClass: "button skillHead",
          attrs: {
            "tag": "a",
            "to": ("" + (skill_.skill_link))
          },
          domProps: {
            "innerHTML": _vm._s(skill_.skill_head)
          },
          nativeOn: {
            "click": function($event) {
              _vm.store.commit('tabModeSet', '03')
            }
          }
        }) : _vm._e(), _vm._v(" "), (skill_.skill_link_tab_index === '4') ? _c('router-link', {
          staticClass: "button skillHead",
          attrs: {
            "tag": "a",
            "to": ("" + (skill_.skill_link))
          },
          domProps: {
            "innerHTML": _vm._s(skill_.skill_head)
          },
          nativeOn: {
            "click": function($event) {
              _vm.store.commit('tabModeSet', '04')
            }
          }
        }) : _vm._e(), _vm._v(" "), (skill_.skill_link_tab_index === '5') ? _c('a', {
          staticClass: "button skillHead",
          attrs: {
            "href": "http://www.eande.world",
            "target": "_blank"
          },
          domProps: {
            "innerHTML": _vm._s(skill_.skill_head)
          }
        }, [_vm._v(":")]) : _vm._e(), _vm._v(" "), _c('span', {
          staticClass: "skillBody"
        }, [_vm._v(_vm._s(skill_.skill_body))])], 1)]) : (skill_.skill_head != null && skill_.skill_link == null) ? _c('div', [_c('div', [_c('b', {
          staticClass: "skillHead",
          domProps: {
            "innerHTML": _vm._s(skill_.skill_head)
          }
        }), _vm._v(" "), _c('span', {
          staticClass: "skillBody"
        }, [_vm._v(_vm._s(skill_.skill_body))])])]) : _vm._e()])
      })], 2)
    })], 2)
  }))])
},staticRenderFns: []}

/***/ })
]),[38]);


// WEBPACK FOOTER //
// static/js/app.79d0495356bc751a13fc.js